import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Timestamp: any;
};

export type AddExternalUserInput = {
  email: Scalars['String'];
  sendEmail: Scalars['Boolean'];
};

export type AddUserInput = {
  companyRoleIDs?: InputMaybe<Array<Scalars['Int']>>;
  email: Scalars['String'];
  roleId: Scalars['Int'];
  sendEmail: Scalars['Boolean'];
};

export type AllowedIp = {
  __typename?: 'AllowedIp';
  description: Scalars['String'];
  id: Scalars['Int'];
  ip: Scalars['String'];
};

export type AllowedIpInput = {
  description: Scalars['String'];
  ip: Scalars['String'];
};

export type AllowedIpsResponse = {
  __typename?: 'AllowedIpsResponse';
  allowedIps: Maybe<Array<AllowedIp>>;
  isIpRestricted: Scalars['Boolean'];
};

export type Application = {
  __typename?: 'Application';
  applicationSteps: Array<ApplicationStep>;
  canceledRoomIds: Array<Scalars['Int']>;
  comment: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  creatorId: Scalars['Int'];
  id: Scalars['Int'];
  isWaitingYourConfirmation: Scalars['Boolean'];
  notifiedUserEmails: Array<Scalars['String']>;
  projectId: Scalars['String'];
  roomIds: Array<Scalars['Int']>;
  status: Scalars['String'];
  title: Scalars['String'];
  workflowId: Scalars['Int'];
};

export type ApplicationInput = {
  applicationSteps: Array<ApplicationStepInput>;
  comment?: InputMaybe<Scalars['String']>;
  notifiedUserEmails: Array<Scalars['String']>;
  projectId: Scalars['String'];
  roomIds: Array<Scalars['Int']>;
  title: Scalars['String'];
  type: ApplicationType;
  workflowId: Scalars['Int'];
};

export type ApplicationResponse = {
  __typename?: 'ApplicationResponse';
  application: Application;
};

export enum ApplicationStatus {
  ApprovalCanceled = 'approvalCanceled',
  Approved = 'approved',
  Canceled = 'canceled',
  Rejected = 'rejected',
  Reviewing = 'reviewing',
  Waiting = 'waiting'
}

export type ApplicationStep = {
  __typename?: 'ApplicationStep';
  applicationStepConfirmations: Array<ApplicationStepConfirmation>;
  dueDate: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  multiApproverCondition: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stepNumber: Scalars['Int'];
};

export type ApplicationStepConfirmation = {
  __typename?: 'ApplicationStepConfirmation';
  comment: Maybe<Scalars['String']>;
  confirmedAt: Maybe<Scalars['String']>;
  confirmerId: Scalars['Int'];
  id: Scalars['Int'];
  isProxy: Scalars['Boolean'];
  status: Scalars['String'];
};

export type ApplicationStepConfirmationInput = {
  confirmerId: Scalars['Int'];
};

export type ApplicationStepInput = {
  confirmations: Array<ApplicationStepConfirmationInput>;
  dueDate: Scalars['String'];
  stepNumber: Scalars['Int'];
};

export enum ApplicationType {
  Order = 'order',
  Publish = 'publish'
}

export type ApplicationsResponse = {
  __typename?: 'ApplicationsResponse';
  applications: Array<Application>;
};

export type Asset = {
  __typename?: 'Asset';
  category: Scalars['String'];
  data: AssetData;
  externalLink: Scalars['String'];
  fileSize: Scalars['Int'];
  id: Scalars['Int'];
  meta: AssetMeta;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type AssetData = {
  __typename?: 'AssetData';
  thumbUrl: Scalars['String'];
  url: Scalars['String'];
};

export type AssetMeta = {
  __typename?: 'AssetMeta';
  UploadedWorksUserBy: Scalars['Int'];
  fileName: Maybe<Scalars['String']>;
  uploadedAt: Scalars['Int'];
};

export type AssetMetaInput = {
  fileName?: InputMaybe<Scalars['String']>;
  uploadedAt: Scalars['Int'];
};

export type AssignProjectInput = {
  id: Scalars['String'];
  roleId: Scalars['Int'];
};

export type AssignUserInput = {
  id: Scalars['Int'];
  isExternal: Scalars['Boolean'];
};

export type AssignUserProjectsInput = {
  isExternal: Scalars['Boolean'];
  projects: Array<InputMaybe<AssignProjectInput>>;
  sendAssignEmail: Scalars['Boolean'];
};

export type AssignUsersProjectsInput = {
  projectIds: Array<Scalars['String']>;
  roleId: Scalars['Int'];
  sendAssignEmail: Scalars['Boolean'];
  users: Array<AssignUserInput>;
};

export type AssignedProject = {
  __typename?: 'AssignedProject';
  adminUrl: Scalars['String'];
  assignedAt: Scalars['String'];
  id: Scalars['String'];
  isDeleting: Scalars['Boolean'];
  isWorksManaged: Scalars['Boolean'];
  presentationUrl: Scalars['String'];
  role: CompassRole;
  status: ProjectStatus;
  title: Scalars['String'];
};

export type AssingedUser = {
  __typename?: 'AssingedUser';
  assignedAt: Scalars['String'];
  companyRoles: Array<CompanyRole>;
  email: Scalars['String'];
  id: Scalars['Int'];
  isExternal: Scalars['Boolean'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  role: CompassRole;
};

export type AttributeMapping = {
  __typename?: 'AttributeMapping';
  department: Maybe<Scalars['String']>;
  email: Scalars['String'];
  name: Maybe<Scalars['String']>;
};

export type AttributeMappingInput = {
  department?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  session: Session;
};

export type BulkUpdateRoomInput = {
  adminMemo?: InputMaybe<Scalars['String']>;
  floor: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  isSelectEnabled: Scalars['Boolean'];
  memo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  registrationDueDatetime?: InputMaybe<Scalars['String']>;
  roomTypeId: Scalars['Int'];
  selectMasters: Array<RoomSelectMasterInput>;
  wingId: Scalars['Int'];
};

export type BulkUpdateRoomsInput = {
  rooms: Array<BulkUpdateRoomInput>;
};

export type BulkUpdateSelectMastersInput = {
  selectMasters: Array<SelectMasterInput>;
};

export type BulkUpdateUserCancelDetailsInput = {
  userCancelDetails: Array<UserCancelDetailInput>;
};

export type BulkUpdateUserStageDetailsInput = {
  userStageDetails: Array<UserStageDetailInput>;
};

export type BulkUpdateWingsInput = {
  wings: Array<WingInput>;
};

export type CancelApplicationInput = {
  applicationId: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
};

export type CancelSelectAgreementInput = {
  roomIds: Array<Scalars['Int']>;
};

export type CheckLoginSettingPayload = {
  __typename?: 'CheckLoginSettingPayload';
  idpAuthURL: Maybe<Scalars['String']>;
  isIDPassEnabled: Scalars['Boolean'];
  isSAMLEnabled: Scalars['Boolean'];
  isSuperAdmin: Scalars['Boolean'];
};

export type CommonAssetInput = {
  externalLink?: InputMaybe<Scalars['String']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  meta: AssetMetaInput;
  name?: InputMaybe<Scalars['String']>;
  priority: Scalars['Int'];
};

export type CommonPageInput = {
  annotation?: InputMaybe<Scalars['String']>;
  meta: PageMeta;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type CommonPageResponse = {
  __typename?: 'CommonPageResponse';
  annotation: Maybe<Scalars['String']>;
  assets: Array<Asset>;
  id: Scalars['Int'];
  meta: PageMetaResponse;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type CommonPagesResponse = {
  __typename?: 'CommonPagesResponse';
  commonPages: Array<CommonPageResponse>;
};

export type CompanyPolicy = {
  __typename?: 'CompanyPolicy';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CompanyResponse = {
  __typename?: 'CompanyResponse';
  id: Scalars['Int'];
  isIDPassEnabled: Scalars['Boolean'];
  isSAMLEnabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CompanyRole = {
  __typename?: 'CompanyRole';
  id: Scalars['Int'];
  name: Scalars['String'];
  policyIds: Array<Scalars['Int']>;
  users: Array<UserIndex>;
};

export type CompanyRoleInput = {
  name: Scalars['String'];
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CompanyRolesResponse = {
  __typename?: 'CompanyRolesResponse';
  roles: Maybe<Array<CompanyRole>>;
};

export type CompassRole = {
  __typename?: 'CompassRole';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type CompassUserInput = {
  compassRoleId: Scalars['Int'];
  isExternal: Scalars['Boolean'];
  userId: Scalars['Int'];
};

export type ContractorHistoryActor = {
  __typename?: 'ContractorHistoryActor';
  companyRoleNames: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  type: ContractorHistoryActorType;
};

export enum ContractorHistoryActorType {
  IamUser = 'iamUser',
  WorksUser = 'worksUser'
}

export type CreateApplicationPayload = {
  __typename?: 'CreateApplicationPayload';
  appliedRoomIds: Array<Scalars['Int']>;
};

export type CreateRoomsCsvHeaderMapping = {
  floorColumn: Scalars['String'];
  roomNameColumn: Scalars['String'];
  roomTypeNameColumn: Scalars['String'];
  selectDisabledColumn: Scalars['String'];
  wingNameColumn: Scalars['String'];
};

export type CreateRoomsCsvInput = {
  autoGenerateFloor: Scalars['Boolean'];
  autoGenerateWing: Scalars['Boolean'];
  csvData: Scalars['String'];
  csvHeaderMapping: CreateRoomsCsvHeaderMapping;
};

export type CreateRoomsCsvPayload = {
  __typename?: 'CreateRoomsCSVPayload';
  errorMessage: Scalars['String'];
  rooms: Array<CreatedRoom>;
};

export type CreatedRoom = {
  __typename?: 'CreatedRoom';
  floor: Scalars['String'];
  message: Scalars['String'];
  result: Scalars['String'];
  roomName: Scalars['String'];
  roomTypeName: Scalars['String'];
  selectDisabled: Scalars['Boolean'];
  wingName: Scalars['String'];
};

export type Creator = {
  __typename?: 'Creator';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum CustomError {
  NotFoundRoomToApply = 'notFoundRoomToApply'
}

export type CustomerProject = {
  __typename?: 'CustomerProject';
  createdAt: Scalars['String'];
  currentSignInAt: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inviterName: Maybe<Scalars['String']>;
  isRoomIamUser: Scalars['Boolean'];
  projectCustomerName: Maybe<Scalars['String']>;
  roomNames: Array<Maybe<Scalars['String']>>;
  title: Scalars['String'];
};

export type CustomerProjectsResponse = {
  __typename?: 'CustomerProjectsResponse';
  customerProjects: Array<CustomerProject>;
};

export type Details = {
  __typename?: 'Details';
  idpSignout: Scalars['String'];
  metadataFile: Maybe<Scalars['String']>;
  metadataFileName: Maybe<Scalars['String']>;
  metadataURL: Maybe<Scalars['String']>;
};

export type DiffRoom = {
  __typename?: 'DiffRoom';
  room: Room;
  type: DiffType;
};

export type DiffRoomsResponse = {
  __typename?: 'DiffRoomsResponse';
  rooms: Array<DiffRoom>;
};

export enum DiffType {
  Created = 'created',
  Deleted = 'deleted',
  Raw = 'raw',
  Updated = 'updated'
}

export type Editor = {
  __typename?: 'Editor';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EmailDomain = {
  __typename?: 'EmailDomain';
  allowedDomain: Scalars['String'];
  id: Scalars['Int'];
};

export type EmailDomainsResponse = {
  __typename?: 'EmailDomainsResponse';
  emailDomains: Array<Maybe<EmailDomain>>;
};

export type ExcludeRoomsFromOrderApplicationInput = {
  comment?: InputMaybe<Scalars['String']>;
  roomIds: Array<Scalars['Int']>;
};

export type ExcludeRoomsFromPublishApplicationInput = {
  comment?: InputMaybe<Scalars['String']>;
  roomIds: Array<Scalars['Int']>;
};

export type ExternalCompassUserInput = {
  userId: Scalars['Int'];
};

export type ExternalUser = {
  __typename?: 'ExternalUser';
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  projects: Maybe<Array<AssignedProject>>;
  updatedAt: Scalars['String'];
};

export type ExternalUserIndex = {
  __typename?: 'ExternalUserIndex';
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  projectCount: Scalars['Int'];
};

export type ExternalUserResponse = {
  __typename?: 'ExternalUserResponse';
  user: ExternalUser;
};

export type ExternalUsersResponse = {
  __typename?: 'ExternalUsersResponse';
  pagination: Pagination;
  users: Maybe<Array<ExternalUserIndex>>;
};

export type ForceUpdatePasswordInput = {
  password: Scalars['String'];
  sendEmail: Scalars['Boolean'];
};

export type ForgetPasswordInput = {
  email: Scalars['String'];
};

export type GroupingRoom = {
  __typename?: 'GroupingRoom';
  groupingKey: Scalars['String'];
  id: Scalars['Int'];
};

export type GroupingRoomsResponse = {
  __typename?: 'GroupingRoomsResponse';
  rooms: Array<GroupingRoom>;
};

export type Identification = {
  __typename?: 'Identification';
  code: Maybe<Scalars['String']>;
  status: IdentificationStatus;
};

export enum IdentificationStatus {
  Approved = 'approved',
  Issued = 'issued',
  Waiting = 'waiting'
}

export enum ImportJobStatus {
  Failed = 'failed',
  PartFailed = 'part_failed',
  Processing = 'processing',
  Successful = 'successful'
}

export type ImportOptoutInput = {
  jobId: Scalars['String'];
  s3URL: Scalars['String'];
};

export type ImportOptoutJobPartFailedError = {
  __typename?: 'ImportOptoutJobPartFailedError';
  message: Scalars['String'];
  row: Scalars['Int'];
};

export type ImportOptoutJobResponse = {
  __typename?: 'ImportOptoutJobResponse';
  failedError: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
  partFailedAbnormalErrorCount: Maybe<Scalars['Int']>;
  partFailedError: Maybe<Array<ImportOptoutJobPartFailedError>>;
  partFailedNormalErrorCount: Maybe<Scalars['Int']>;
  partFailedTotalCount: Maybe<Scalars['Int']>;
  rowCount: Scalars['Int'];
  status: ImportJobStatus;
  updatedAt: Scalars['String'];
};

export type ImportRoomUsersInput = {
  jobId: Scalars['String'];
  s3URL: Scalars['String'];
};

export type ImportRoomUsersJobErrorDetail = {
  __typename?: 'ImportRoomUsersJobErrorDetail';
  line: Scalars['Int'];
  message: Scalars['String'];
};

export type ImportRoomUsersJobResponse = {
  __typename?: 'ImportRoomUsersJobResponse';
  errorDetails: Maybe<Array<ImportRoomUsersJobErrorDetail>>;
  errorMessage: Maybe<Scalars['String']>;
  errorReportS3Url: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
  lineCount: Scalars['Int'];
  status: ImportJobStatus;
  updatedAt: Scalars['String'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LogoutInput = {
  refreshToken: Scalars['String'];
};

export type MainContent = {
  __typename?: 'MainContent';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MasterDataResponse = {
  __typename?: 'MasterDataResponse';
  companyPolicies: Maybe<Array<Maybe<CompanyPolicy>>>;
  worksRoles: Maybe<Array<Maybe<WorksRole>>>;
};

export type Meta = {
  __typename?: 'Meta';
  createdAt: Scalars['String'];
  createdBy: Editor;
  updatedAt: Scalars['String'];
  updatedBy: Editor;
};

export type Metadata = {
  metadataFile?: InputMaybe<Scalars['String']>;
  metadataFileName?: InputMaybe<Scalars['String']>;
  metadataURL?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addExternalUser: Maybe<Scalars['Boolean']>;
  addUser: Maybe<Scalars['Boolean']>;
  assignUserProjects: Maybe<Scalars['Boolean']>;
  assignUsersProjects: Maybe<Scalars['Boolean']>;
  bulkUpdateRooms: Maybe<Scalars['Boolean']>;
  bulkUpdateSelectMasters: Maybe<Scalars['Boolean']>;
  bulkUpdateUserCancelDetails: UserCancelDetailsResponse;
  bulkUpdateUserStageDetails: UserStageDetailsResponse;
  bulkUpdateWings: Maybe<Scalars['Boolean']>;
  cancelApplication: Maybe<Scalars['Boolean']>;
  cancelSelectAgreement: Maybe<Scalars['Boolean']>;
  checkLoginSetting: CheckLoginSettingPayload;
  copySelectMaster: Maybe<Scalars['Boolean']>;
  createAllowedIp: Maybe<Scalars['Boolean']>;
  createApplication: CreateApplicationPayload;
  createCommonAsset: Maybe<Scalars['Boolean']>;
  createCommonPage: Maybe<Scalars['Boolean']>;
  createCompanyRole: Maybe<Scalars['Boolean']>;
  createProject: Maybe<Scalars['String']>;
  createRoomsCSV: Maybe<CreateRoomsCsvPayload>;
  createSAMLIdp: Maybe<Scalars['Boolean']>;
  createSelectMaster: Maybe<Scalars['Boolean']>;
  createWorkflow: Maybe<Scalars['Boolean']>;
  deleteAllowedIp: Maybe<Scalars['Boolean']>;
  deleteCommonAsset: Maybe<Scalars['Boolean']>;
  deleteCommonPage: Maybe<Scalars['Boolean']>;
  deleteCompanyRole: Maybe<Scalars['Boolean']>;
  deleteCustomer: Maybe<Scalars['Boolean']>;
  deleteProject: Maybe<Scalars['String']>;
  deleteRoom: Maybe<Scalars['Boolean']>;
  deleteSAMLIdp: Maybe<Scalars['Boolean']>;
  deleteSelectMaster: Maybe<Scalars['Boolean']>;
  deleteUser: Maybe<Scalars['Boolean']>;
  deleteWorkflow: Maybe<Scalars['Boolean']>;
  destroyRoomUser: Maybe<Scalars['Boolean']>;
  exchangeAuthCodeWithAccessToken: Maybe<AuthPayload>;
  excludeRoomsFromOrderApplication: Maybe<Scalars['Boolean']>;
  excludeRoomsFromPublishApplication: Maybe<Scalars['Boolean']>;
  forceUpdateExternalUserPassword: Maybe<Scalars['Boolean']>;
  forceUpdateUserPassword: Maybe<Scalars['Boolean']>;
  forgetPassword: Maybe<Scalars['Boolean']>;
  importOptout: Maybe<Scalars['Boolean']>;
  importRoomUsers: Maybe<Scalars['Boolean']>;
  login: Maybe<AuthPayload>;
  logout: Maybe<Scalars['Boolean']>;
  presignedURLOptoutImport: PresignedUrlPayload;
  presignedURLRoomUsersImport: PresignedUrlPayload;
  refreshAccessToken: Maybe<AuthPayload>;
  registerRoomUser: Maybe<Scalars['Boolean']>;
  registerSelects: Maybe<Scalars['Boolean']>;
  relateUsersToCompass: RelateUsersToCompassPayload;
  reorderCommonAssets: Maybe<Scalars['Boolean']>;
  reorderCommonPages: Maybe<Scalars['Boolean']>;
  sendSelectEmails: Maybe<Scalars['Boolean']>;
  sendTmpPassword: SendTmpPasswordPayload;
  setupCompany: SetupCompanyPayload;
  switchCompanyWorksCustomRole: Maybe<Scalars['Boolean']>;
  updateAllowedIp: Maybe<Scalars['Boolean']>;
  updateApplicationStepConfirmation: Maybe<Scalars['Boolean']>;
  updateCommonAsset: Maybe<Scalars['Boolean']>;
  updateCommonPage: Maybe<Scalars['Boolean']>;
  updateCompanyAuthMethod: Maybe<Scalars['Boolean']>;
  updateCompanyRole: Maybe<Scalars['Boolean']>;
  updateCompassRole: Maybe<Scalars['Boolean']>;
  updateExternalUserName: Maybe<Scalars['Boolean']>;
  updateImportOptoutJob: Maybe<Scalars['Boolean']>;
  updateInitPassword: Maybe<Scalars['Boolean']>;
  updateInternalUserName: Maybe<Scalars['Boolean']>;
  updateIpRestriction: Maybe<Scalars['Boolean']>;
  updatePassword: Maybe<Scalars['Boolean']>;
  updateProfileName: Maybe<Scalars['Boolean']>;
  updateProject: Maybe<Scalars['String']>;
  updateProjectShowCommonPage: Maybe<Scalars['Boolean']>;
  updateRoom: Maybe<Scalars['Boolean']>;
  updateRoomUserConfirmationCode: Maybe<Scalars['Boolean']>;
  updateRoomsPriority: Maybe<Scalars['Boolean']>;
  updateSAMLIdp: Maybe<Scalars['Boolean']>;
  updateSelectMaster: Maybe<Scalars['Boolean']>;
  updateSelectMasterPriorities: Maybe<Scalars['Boolean']>;
  updateUserCompanyRoles: Maybe<Scalars['Boolean']>;
  updateUserKeywords: Maybe<Scalars['Boolean']>;
  updateWorksRole: Maybe<Scalars['Boolean']>;
};


export type MutationAddExternalUserArgs = {
  params: AddExternalUserInput;
};


export type MutationAddUserArgs = {
  params: AddUserInput;
};


export type MutationAssignUserProjectsArgs = {
  params: AssignUserProjectsInput;
  userId: Scalars['Int'];
};


export type MutationAssignUsersProjectsArgs = {
  params: AssignUsersProjectsInput;
};


export type MutationBulkUpdateRoomsArgs = {
  params: BulkUpdateRoomsInput;
  projectId: Scalars['String'];
};


export type MutationBulkUpdateSelectMastersArgs = {
  params: BulkUpdateSelectMastersInput;
  projectId: Scalars['String'];
};


export type MutationBulkUpdateUserCancelDetailsArgs = {
  params: BulkUpdateUserCancelDetailsInput;
};


export type MutationBulkUpdateUserStageDetailsArgs = {
  params: BulkUpdateUserStageDetailsInput;
};


export type MutationBulkUpdateWingsArgs = {
  params: BulkUpdateWingsInput;
  projectId: Scalars['String'];
};


export type MutationCancelApplicationArgs = {
  params: CancelApplicationInput;
};


export type MutationCancelSelectAgreementArgs = {
  params: CancelSelectAgreementInput;
  projectId: Scalars['String'];
};


export type MutationCheckLoginSettingArgs = {
  email: Scalars['String'];
};


export type MutationCopySelectMasterArgs = {
  projectId: Scalars['String'];
  selectMasterId: Scalars['Int'];
};


export type MutationCreateAllowedIpArgs = {
  params: AllowedIpInput;
};


export type MutationCreateApplicationArgs = {
  params: ApplicationInput;
};


export type MutationCreateCommonAssetArgs = {
  commonPageId: Scalars['Int'];
  params: CommonAssetInput;
};


export type MutationCreateCommonPageArgs = {
  params: CommonPageInput;
};


export type MutationCreateCompanyRoleArgs = {
  params: CompanyRoleInput;
};


export type MutationCreateProjectArgs = {
  params: ProjectInput;
};


export type MutationCreateRoomsCsvArgs = {
  params: CreateRoomsCsvInput;
  projectId: Scalars['String'];
};


export type MutationCreateSamlIdpArgs = {
  companyId: Scalars['Int'];
  params: SamlIdpInput;
};


export type MutationCreateSelectMasterArgs = {
  params: SelectMasterInput;
  projectId: Scalars['String'];
};


export type MutationCreateWorkflowArgs = {
  params: WorkflowInput;
};


export type MutationDeleteAllowedIpArgs = {
  allowedIpId: Scalars['Int'];
};


export type MutationDeleteCommonAssetArgs = {
  commonAssetId: Scalars['Int'];
  commonPageId: Scalars['Int'];
};


export type MutationDeleteCommonPageArgs = {
  commonPageId: Scalars['Int'];
};


export type MutationDeleteCompanyRoleArgs = {
  roleId: Scalars['Int'];
};


export type MutationDeleteCustomerArgs = {
  email: Scalars['String'];
};


export type MutationDeleteProjectArgs = {
  projectId: Scalars['String'];
};


export type MutationDeleteRoomArgs = {
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type MutationDeleteSamlIdpArgs = {
  companyId: Scalars['Int'];
  identityProviderId: Scalars['Int'];
};


export type MutationDeleteSelectMasterArgs = {
  projectId: Scalars['String'];
  selectMasterId: Scalars['Int'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['Int'];
};


export type MutationDeleteWorkflowArgs = {
  workflowId: Scalars['Int'];
};


export type MutationDestroyRoomUserArgs = {
  iamUserId: Scalars['Int'];
  roomId: Scalars['Int'];
};


export type MutationExchangeAuthCodeWithAccessTokenArgs = {
  code: Scalars['String'];
};


export type MutationExcludeRoomsFromOrderApplicationArgs = {
  params: ExcludeRoomsFromOrderApplicationInput;
  projectId: Scalars['String'];
};


export type MutationExcludeRoomsFromPublishApplicationArgs = {
  params: ExcludeRoomsFromPublishApplicationInput;
  projectId: Scalars['String'];
};


export type MutationForceUpdateExternalUserPasswordArgs = {
  params: ForceUpdatePasswordInput;
  userId: Scalars['Int'];
};


export type MutationForceUpdateUserPasswordArgs = {
  params: ForceUpdatePasswordInput;
  userId: Scalars['Int'];
};


export type MutationForgetPasswordArgs = {
  params: ForgetPasswordInput;
};


export type MutationImportOptoutArgs = {
  params: ImportOptoutInput;
};


export type MutationImportRoomUsersArgs = {
  params: ImportRoomUsersInput;
};


export type MutationLoginArgs = {
  params: LoginInput;
};


export type MutationLogoutArgs = {
  params: LogoutInput;
};


export type MutationRefreshAccessTokenArgs = {
  params: RefreshAccessTokenInput;
};


export type MutationRegisterRoomUserArgs = {
  params: RegisterRoomUserInput;
};


export type MutationRegisterSelectsArgs = {
  params: RegisterSelectsInput;
  projectId: Scalars['String'];
};


export type MutationRelateUsersToCompassArgs = {
  params: RelateUsersToCompassInput;
};


export type MutationReorderCommonAssetsArgs = {
  commonPageId: Scalars['Int'];
  params: ReorderCommonAssetInput;
};


export type MutationReorderCommonPagesArgs = {
  params: ReorderCommonPageInput;
};


export type MutationSendSelectEmailsArgs = {
  params: SendSelectEmailsInput;
  projectId: Scalars['String'];
};


export type MutationSendTmpPasswordArgs = {
  params: SendTmpPasswordInput;
};


export type MutationSetupCompanyArgs = {
  params: SetupCompanyInput;
};


export type MutationSwitchCompanyWorksCustomRoleArgs = {
  apiKey: Scalars['String'];
  companyId: Scalars['Int'];
};


export type MutationUpdateAllowedIpArgs = {
  allowedIpId: Scalars['Int'];
  params: AllowedIpInput;
};


export type MutationUpdateApplicationStepConfirmationArgs = {
  params: UpdateApplicationStepConfirmationInput;
};


export type MutationUpdateCommonAssetArgs = {
  commonAssetId: Scalars['Int'];
  commonPageId: Scalars['Int'];
  params: CommonAssetInput;
};


export type MutationUpdateCommonPageArgs = {
  commonPageId: Scalars['Int'];
  params: CommonPageInput;
};


export type MutationUpdateCompanyAuthMethodArgs = {
  companyId: Scalars['Int'];
  params: UpdateCompanyAuthMethodInput;
};


export type MutationUpdateCompanyRoleArgs = {
  params: CompanyRoleInput;
  roleId: Scalars['Int'];
};


export type MutationUpdateCompassRoleArgs = {
  params: UpdateCompassRoleInput;
};


export type MutationUpdateExternalUserNameArgs = {
  name: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUpdateImportOptoutJobArgs = {
  params: UpdateImportOptoutJobInput;
};


export type MutationUpdateInitPasswordArgs = {
  params: UpdateInitPasswordInput;
};


export type MutationUpdateInternalUserNameArgs = {
  name: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUpdateIpRestrictionArgs = {
  params: UpdateIpRestrictionInput;
};


export type MutationUpdatePasswordArgs = {
  params: UpdatePasswordInput;
};


export type MutationUpdateProfileNameArgs = {
  name: Scalars['String'];
};


export type MutationUpdateProjectArgs = {
  params: ProjectInput;
  projectId: Scalars['String'];
};


export type MutationUpdateProjectShowCommonPageArgs = {
  params: ProjectShowCommonPageInput;
  projectId: Scalars['String'];
};


export type MutationUpdateRoomArgs = {
  params: RoomInput;
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type MutationUpdateRoomUserConfirmationCodeArgs = {
  params: UpdateRoomUserConfirmationCodeInput;
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type MutationUpdateRoomsPriorityArgs = {
  prioritizedRoomIds: Array<Scalars['Int']>;
  projectId: Scalars['String'];
};


export type MutationUpdateSamlIdpArgs = {
  companyId: Scalars['Int'];
  identityProviderId: Scalars['Int'];
  params: SamlIdpInput;
};


export type MutationUpdateSelectMasterArgs = {
  params: SelectMasterInput;
  projectId: Scalars['String'];
  selectMasterId: Scalars['Int'];
};


export type MutationUpdateSelectMasterPrioritiesArgs = {
  projectId: Scalars['String'];
  selectMasterIds: Array<Scalars['Int']>;
};


export type MutationUpdateUserCompanyRolesArgs = {
  params: UpdateCompanyRolesInput;
  userId: Scalars['Int'];
};


export type MutationUpdateUserKeywordsArgs = {
  params: UpdateUserKeywordsInput;
  userId: Scalars['Int'];
};


export type MutationUpdateWorksRoleArgs = {
  params: UpdateWorksRoleInput;
};

export type MyReviewingConfirmation = {
  __typename?: 'MyReviewingConfirmation';
  applicationCreatedAt: Scalars['String'];
  applicationCreatorId: Scalars['Int'];
  applicationId: Scalars['Int'];
  applicationTitle: Scalars['String'];
  applicationType: ApplicationType;
  applicationWorkflowName: Scalars['String'];
  dueDate: Scalars['String'];
  id: Scalars['Int'];
  projectId: Scalars['String'];
  projectName: Scalars['String'];
};

export type MyReviewingConfirmationsResponse = {
  __typename?: 'MyReviewingConfirmationsResponse';
  confirmations: Array<MyReviewingConfirmation>;
};

export type OgpImageResponse = {
  __typename?: 'OgpImageResponse';
  url: Scalars['String'];
};

export type PageMeta = {
  designFormat: Scalars['String'];
  displayConsumer: Scalars['Boolean'];
  icon: Scalars['Int'];
  isPublic: Scalars['Boolean'];
};

export type PageMetaResponse = {
  __typename?: 'PageMetaResponse';
  designFormat: Scalars['String'];
  displayConsumer: Scalars['Boolean'];
  icon: Scalars['Int'];
  isPublic: Scalars['Boolean'];
};

export type Pagination = {
  __typename?: 'Pagination';
  current: Scalars['Int'];
  limitValue: Scalars['Int'];
  next: Scalars['Int'];
  pageCount: Scalars['Int'];
  previous: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PresignedUrlPayload = {
  __typename?: 'PresignedURLPayload';
  jobId: Scalars['String'];
  presignedURL: Scalars['String'];
  s3URL: Scalars['String'];
};

export type ProfileResponse = {
  __typename?: 'ProfileResponse';
  user: ProfileUser;
};

export type ProfileUser = {
  __typename?: 'ProfileUser';
  companyPolicies: Maybe<Array<CompanyPolicy>>;
  companyRoles: Maybe<Array<CompanyRole>>;
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  isResetPassword: Scalars['Boolean'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  policies: Maybe<Array<Scalars['String']>>;
  projects: Maybe<Array<AssignedProject>>;
  role: WorksRole;
  roleId: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type Project = {
  __typename?: 'Project';
  address: Maybe<Scalars['String']>;
  adminUrl: Scalars['String'];
  applicationCount: Maybe<Scalars['Int']>;
  averagePriceRange: Maybe<Scalars['Int']>;
  city: Maybe<Scalars['String']>;
  code: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  email: Maybe<Scalars['String']>;
  emailDisplayName: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleting: Scalars['Boolean'];
  isWorksManaged: Scalars['Boolean'];
  mainContents: Maybe<Array<MainContent>>;
  planCount: Maybe<Scalars['Int']>;
  prefecture: Scalars['String'];
  presentationUrl: Scalars['String'];
  purchaserCount: Maybe<Scalars['Int']>;
  roomCount: Maybe<Scalars['Int']>;
  showCommonPage: Scalars['Boolean'];
  status: ProjectStatus;
  structureCount: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  totalPvCount: Scalars['Int'];
  totalSessionCount: Scalars['Int'];
  updatedAt: Scalars['String'];
  users: Maybe<Array<AssingedUser>>;
  zipcode: Maybe<Scalars['String']>;
};

export type ProjectCountHistory = {
  __typename?: 'ProjectCountHistory';
  activatedCount: Scalars['Int'];
  month: Scalars['String'];
};

export type ProjectIndex = {
  __typename?: 'ProjectIndex';
  adminUrl: Scalars['String'];
  applicationCount: Maybe<Scalars['Int']>;
  averagePriceRange: Maybe<Scalars['Int']>;
  code: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  creator: Creator;
  id: Scalars['String'];
  isDeleting: Scalars['Boolean'];
  isWorksManaged: Scalars['Boolean'];
  planCount: Maybe<Scalars['Int']>;
  prefecture: Scalars['String'];
  presentationUrl: Scalars['String'];
  purchaserCount: Maybe<Scalars['Int']>;
  roomCount: Maybe<Scalars['Int']>;
  status: ProjectStatus;
  structureCount: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ProjectInput = {
  address?: InputMaybe<Scalars['String']>;
  averagePriceRange?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  compassUsers?: InputMaybe<Array<CompassUserInput>>;
  email?: InputMaybe<Scalars['String']>;
  emailDisplayName?: InputMaybe<Scalars['String']>;
  planCount?: InputMaybe<Scalars['Int']>;
  prefecture: Scalars['String'];
  projectStatusName: Scalars['String'];
  roomCount?: InputMaybe<Scalars['Int']>;
  sendAssignEmail: Scalars['Boolean'];
  structureCount?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  zipcode?: InputMaybe<Scalars['String']>;
};

export type ProjectResponse = {
  __typename?: 'ProjectResponse';
  project: Project;
};

export type ProjectShowCommonPageInput = {
  showCommonPage: Scalars['Boolean'];
};

export type ProjectStatus = {
  __typename?: 'ProjectStatus';
  displayName: Scalars['String'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type ProjectStatusesResponse = {
  __typename?: 'ProjectStatusesResponse';
  projectStatuses: Array<ProjectStatus>;
};

export type ProjectSummaryResponse = {
  __typename?: 'ProjectSummaryResponse';
  projectCountHistories: Maybe<Array<ProjectCountHistory>>;
};

export type ProjectsResponse = {
  __typename?: 'ProjectsResponse';
  pagination: Pagination;
  projects: Maybe<Array<ProjectIndex>>;
};

export type Query = {
  __typename?: 'Query';
  allRoomSelectRegistrations: RoomSelectRegistrationsResponse;
  allowedIps: AllowedIpsResponse;
  application: ApplicationResponse;
  applications: ApplicationsResponse;
  cachedRooms: RoomsResponse;
  commonPage: CommonPageResponse;
  commonPages: CommonPagesResponse;
  company: CompanyResponse;
  companyRoles: CompanyRolesResponse;
  compassRoles: CompassRolesResponse;
  customerProjects: CustomerProjectsResponse;
  diffRooms: DiffRoomsResponse;
  emailDomains: EmailDomainsResponse;
  externalUser: ExternalUserResponse;
  externalUsers: ExternalUsersResponse;
  groupingRooms: GroupingRoomsResponse;
  latestImportOptoutJob: ImportOptoutJobResponse;
  latestImportRoomUsersJob: ImportRoomUsersJobResponse;
  masterData: MasterDataResponse;
  myReviewingConfirmations: MyReviewingConfirmationsResponse;
  ogpImage: OgpImageResponse;
  profile: ProfileResponse;
  project: ProjectResponse;
  projectStatuses: ProjectStatusesResponse;
  projectSummary: ProjectSummaryResponse;
  projects: ProjectsResponse;
  roomApplicationStatus: RoomApplicationStatusResponse;
  roomSelectMasters: RoomSelectMastersResponse;
  roomSelectRegistrations: RoomSelectRegistrationsResponse;
  roomTypes: RoomTypesResponse;
  rooms: RoomsResponse;
  samlIdp: SamlIdpResponse;
  selectContractorHistories: SelectContractorHistoriesResponse;
  selectMasters: SelectMastersResponse;
  selectRegistrations: SelectRegistrationsResponse;
  selects: SelectsResponse;
  user: UserResponse;
  userCancelDetailUsageCheck: UserCancelDetailUsageCheckResponse;
  userCancelDetails: UserCancelDetailsResponse;
  userStageDetailUsageCheck: UserStageDetailUsageCheckResponse;
  userStageDetails: UserStageDetailsResponse;
  users: UsersResponse;
  wings: WingsResponse;
  workflows: WorkflowsResponse;
};


export type QueryAllRoomSelectRegistrationsArgs = {
  projectId: Scalars['String'];
};


export type QueryApplicationArgs = {
  id: Scalars['Int'];
};


export type QueryApplicationsArgs = {
  projectId: Scalars['String'];
};


export type QueryCachedRoomsArgs = {
  projectId: Scalars['String'];
};


export type QueryCommonPageArgs = {
  id: Scalars['Int'];
};


export type QueryCustomerProjectsArgs = {
  email: Scalars['String'];
};


export type QueryDiffRoomsArgs = {
  projectId: Scalars['String'];
};


export type QueryExternalUserArgs = {
  id: Scalars['Int'];
};


export type QueryGroupingRoomsArgs = {
  projectId: Scalars['String'];
};


export type QueryOgpImageArgs = {
  url: Scalars['String'];
};


export type QueryProjectArgs = {
  id: Scalars['String'];
};


export type QueryRoomApplicationStatusArgs = {
  params: InputMaybe<RoomApplicationStatusInput>;
};


export type QueryRoomSelectMastersArgs = {
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type QueryRoomSelectRegistrationsArgs = {
  projectId: Scalars['String'];
  roomIds: Array<Scalars['Int']>;
};


export type QueryRoomTypesArgs = {
  projectId: Scalars['String'];
};


export type QueryRoomsArgs = {
  projectId: Scalars['String'];
};


export type QuerySelectContractorHistoriesArgs = {
  roomId: Scalars['Int'];
};


export type QuerySelectMastersArgs = {
  projectId: Scalars['String'];
};


export type QuerySelectRegistrationsArgs = {
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type QuerySelectsArgs = {
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};


export type QueryUserCancelDetailUsageCheckArgs = {
  userCancelDetailId: Scalars['Int'];
};


export type QueryUserStageDetailUsageCheckArgs = {
  userStageDetailId: Scalars['Int'];
};


export type QueryWingsArgs = {
  projectId: Scalars['String'];
};

export type RefreshAccessTokenInput = {
  cognitoUsername: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type RegisterRoomUserInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  roomId: Scalars['Int'];
};

export type RegisterSelectsInput = {
  roomId: Scalars['Int'];
  selects: Array<SelectInput>;
};

export type RegisteredSelectOption = {
  __typename?: 'RegisteredSelectOption';
  child: Maybe<RegisteredSelectOptionChild>;
  id: Scalars['Int'];
  isPaid: Scalars['Boolean'];
  name: Scalars['String'];
};

export type RegisteredSelectOptionChild = {
  __typename?: 'RegisteredSelectOptionChild';
  id: Scalars['Int'];
  isPaid: Scalars['Boolean'];
  name: Scalars['String'];
};

export type RelateUsersToCompassFailedUser = {
  __typename?: 'RelateUsersToCompassFailedUser';
  email: Scalars['String'];
  message: Scalars['String'];
};

export type RelateUsersToCompassInput = {
  apiKey: Scalars['String'];
  usersInput: Array<UserInput>;
  worksCompanyId: Scalars['Int'];
  worksRoleName: Scalars['String'];
};

export type RelateUsersToCompassPayload = {
  __typename?: 'RelateUsersToCompassPayload';
  failedUsers: Maybe<Array<RelateUsersToCompassFailedUser>>;
  successUsers: Maybe<Array<RelateUsersToCompassSuccessUser>>;
};

export type RelateUsersToCompassSuccessUser = {
  __typename?: 'RelateUsersToCompassSuccessUser';
  email: Scalars['String'];
  tmpPassword: Scalars['String'];
};

export type ReorderCommonAssetInput = {
  commonAssetsPriorities: Array<Scalars['Int']>;
};

export type ReorderCommonPageInput = {
  commonPagesPriorities: Array<Scalars['Int']>;
};

export type Room = {
  __typename?: 'Room';
  adminMemo: Maybe<Scalars['String']>;
  confirmationCode: Maybe<Scalars['String']>;
  floor: Scalars['String'];
  id: Scalars['Int'];
  isEnableCancelOrderApplication: Scalars['Boolean'];
  isEnableCancelPublishApplication: Scalars['Boolean'];
  isEnableCancelSelectAgreement: Scalars['Boolean'];
  isEnableChangeToUnselectable: Scalars['Boolean'];
  isEnableExcludeRoomsFromOrderApplication: Scalars['Boolean'];
  isEnableExcludeRoomsFromPublishApplication: Scalars['Boolean'];
  isEnableOrderApplication: Scalars['Boolean'];
  isEnableProxySelectRegistration: Scalars['Boolean'];
  isEnablePublishApplication: Scalars['Boolean'];
  isEnableRoomUserDestroy: Scalars['Boolean'];
  isEnableRoomUserRegistration: Scalars['Boolean'];
  isEnableSelectEmailAgreementRequest: Scalars['Boolean'];
  isEnableSelectEmailInvitation: Scalars['Boolean'];
  isEnableUpdateConfirmationCode: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  isSelectEnabled: Scalars['Boolean'];
  memo: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orderApplicationCancelComment: Maybe<Scalars['String']>;
  orderApplicationCanceledAt: Maybe<Scalars['String']>;
  orderApplicationStatus: ApplicationStatus;
  priority: Scalars['Int'];
  publishApplicationStatus: ApplicationStatus;
  registrationDueDatetime: Scalars['String'];
  registrationStatus: SelectRegistrationStatus;
  roomTypeId: Maybe<Scalars['Int']>;
  roomTypeName: Maybe<Scalars['String']>;
  selectMasterIds: Array<Scalars['Int']>;
  source: RoomSourceType;
  user: Maybe<RoomUser>;
  wingId: Scalars['Int'];
  wingName: Scalars['String'];
};

export type RoomApplicationStatus = {
  __typename?: 'RoomApplicationStatus';
  orderApplicationStatus: ApplicationStatus;
  publishApplicationStatus: ApplicationStatus;
};

export type RoomApplicationStatusInput = {
  canceledOrderApplicationID?: InputMaybe<Scalars['Int']>;
  canceledPublishApplicationID?: InputMaybe<Scalars['Int']>;
  orderApplicationID?: InputMaybe<Scalars['Int']>;
  publishApplicationID?: InputMaybe<Scalars['Int']>;
  roomId: Scalars['Int'];
};

export type RoomApplicationStatusResponse = {
  __typename?: 'RoomApplicationStatusResponse';
  roomApplicationStatus: RoomApplicationStatus;
};

export type RoomInput = {
  adminMemo?: InputMaybe<Scalars['String']>;
  isSelectEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type RoomSelect = {
  __typename?: 'RoomSelect';
  id: Scalars['Int'];
  selects: Array<SelectRegistration>;
};

export type RoomSelectMaster = {
  __typename?: 'RoomSelectMaster';
  id: Scalars['Int'];
  selectOptionMasterIds: Array<Scalars['Int']>;
};

export type RoomSelectMasterInput = {
  id: Scalars['Int'];
  isDelete?: InputMaybe<Scalars['Boolean']>;
  selectOptionMasterIds: Array<Scalars['Int']>;
};

export type RoomSelectMastersResponse = {
  __typename?: 'RoomSelectMastersResponse';
  selectMasters: Array<RoomSelectMaster>;
};

export type RoomSelectRegistrationsResponse = {
  __typename?: 'RoomSelectRegistrationsResponse';
  rooms: Array<RoomSelect>;
};

export type RoomType = {
  __typename?: 'RoomType';
  compassRoomCount: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  worksRoomIds: Maybe<Array<Scalars['Int']>>;
};

export type RoomTypeInput = {
  id?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type RoomTypesResponse = {
  __typename?: 'RoomTypesResponse';
  roomTypes: Array<RoomType>;
};

export type RoomUser = {
  __typename?: 'RoomUser';
  agreementRequestEmailSentTimes: Scalars['Int'];
  email: Scalars['String'];
  id: Scalars['Int'];
  identification: Identification;
  lastAgreementRequestEmailSentAt: Maybe<Scalars['String']>;
  lastSelectEmailSentAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  selectEmailSentTimes: Scalars['Int'];
};

export type RoomsResponse = {
  __typename?: 'RoomsResponse';
  rooms: Array<Room>;
};

export type SamlIdp = {
  __typename?: 'SAMLIdp';
  attributeMapping: AttributeMapping;
  id: Scalars['Int'];
  idpSignout: Scalars['Boolean'];
  metadataFile: Maybe<Scalars['String']>;
  metadataFileName: Maybe<Scalars['String']>;
  metadataURL: Maybe<Scalars['String']>;
};

export type SamlIdpInput = {
  attributeMapping: AttributeMappingInput;
  idpSignout: Scalars['Boolean'];
  metadata: Metadata;
};

export type SamlIdpResponse = {
  __typename?: 'SAMLIdpResponse';
  assertionConsumerServiceURL: Scalars['String'];
  samlIdp: Maybe<SamlIdp>;
  serviceProviderURN: Scalars['String'];
};

export type Select = {
  __typename?: 'Select';
  annotation: Scalars['String'];
  assignments: Maybe<SelectMasterAssignments>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  file: Maybe<SelectMasterFile>;
  id: Scalars['Int'];
  isPlanSelect: Scalars['Boolean'];
  modelRoomInfo: Scalars['String'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  selectMasterId: Scalars['Int'];
  selectOptions: Array<SelectOption>;
};

export type SelectContractorHistoriesResponse = {
  __typename?: 'SelectContractorHistoriesResponse';
  histories: Array<SelectContractorHistory>;
};

export type SelectContractorHistory = {
  __typename?: 'SelectContractorHistory';
  action: Scalars['String'];
  actor: Maybe<ContractorHistoryActor>;
  timestamp: Scalars['String'];
};

export enum SelectEmailContent {
  AgreementRequest = 'agreementRequest',
  Invitation = 'invitation'
}

export type SelectInput = {
  id: Scalars['Int'];
  selectOptionIds: Array<Scalars['Int']>;
};

export type SelectMaster = {
  __typename?: 'SelectMaster';
  annotation: Maybe<Scalars['String']>;
  assignments: Maybe<SelectMasterAssignments>;
  description: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  file: Maybe<SelectMasterFile>;
  fileName: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isPlanSelect: Scalars['Boolean'];
  modelRoomInfo: Maybe<Scalars['String']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  roomIds: Array<Scalars['Int']>;
  selectOptionMasters: Array<SelectOptionMaster>;
};

export type SelectMasterAssignments = {
  __typename?: 'SelectMasterAssignments';
  mainContents: Maybe<Array<Scalars['Int']>>;
};

export type SelectMasterAssignmentsInput = {
  mainContents: Array<Scalars['Int']>;
};

export type SelectMasterFile = {
  __typename?: 'SelectMasterFile';
  thumb: SelectMasterFileThumb;
  url: Scalars['String'];
};

export type SelectMasterFileThumb = {
  __typename?: 'SelectMasterFileThumb';
  url: Scalars['String'];
};

export type SelectMasterInput = {
  annotation?: InputMaybe<Scalars['String']>;
  assignments?: InputMaybe<SelectMasterAssignmentsInput>;
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  file?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  isPlanSelect: Scalars['Boolean'];
  isRemoveFile?: InputMaybe<Scalars['Boolean']>;
  modelRoomInfo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  selectOptionMasters: Array<SelectOptionMasterInput>;
};

export type SelectMastersResponse = {
  __typename?: 'SelectMastersResponse';
  selectMasters: Maybe<Array<SelectMaster>>;
};

export type SelectOption = {
  __typename?: 'SelectOption';
  annotation: Scalars['String'];
  children: Maybe<Array<SelectOption>>;
  file: Maybe<SelectMasterFile>;
  id: Scalars['Int'];
  isPaid: Scalars['Boolean'];
  isSelected: Scalars['Boolean'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type SelectOptionMaster = {
  __typename?: 'SelectOptionMaster';
  annotation: Maybe<Scalars['String']>;
  children: Maybe<Array<SelectOptionMaster>>;
  file: Maybe<SelectMasterFile>;
  fileName: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isPaid: Scalars['Boolean'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type SelectOptionMasterInput = {
  annotation?: InputMaybe<Scalars['String']>;
  children?: InputMaybe<Array<SelectOptionMasterInput>>;
  file?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isPaid: Scalars['Boolean'];
  isRemoveFile?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type SelectRegistration = {
  __typename?: 'SelectRegistration';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  registeredSelectOption: Maybe<RegisteredSelectOption>;
  selectMasterId: Scalars['Int'];
};

export enum SelectRegistrationStatus {
  Agreed = 'agreed',
  Registered = 'registered',
  Waiting = 'waiting'
}

export type SelectRegistrationsResponse = {
  __typename?: 'SelectRegistrationsResponse';
  selectRegistrations: Array<SelectRegistration>;
};

export type SelectsResponse = {
  __typename?: 'SelectsResponse';
  selects: Array<Select>;
};

export type SendTmpPasswordFailedUser = {
  __typename?: 'SendTmpPasswordFailedUser';
  email: Scalars['String'];
  message: Scalars['String'];
};

export type SendTmpPasswordInput = {
  apiKey: Scalars['String'];
  inviterName: Scalars['String'];
  users: Array<SendTmpPasswordUserInput>;
};

export type SendTmpPasswordPayload = {
  __typename?: 'SendTmpPasswordPayload';
  failedUsers: Maybe<Array<SendTmpPasswordFailedUser>>;
  successUserEmails: Maybe<Array<Scalars['String']>>;
};

export type SendTmpPasswordUserInput = {
  email: Scalars['String'];
  tmpPassword: Scalars['String'];
};

export type Session = {
  __typename?: 'Session';
  accessToken: Scalars['String'];
  accessTokenExpiresAt: Scalars['String'];
  cognitoUsername: Scalars['String'];
  refreshToken: Scalars['String'];
  refreshTokenExpiresAt: Scalars['String'];
};

export type SetupCompanyInput = {
  apiKey: Scalars['String'];
  companyName: Scalars['String'];
  compassCompanyId: Scalars['Int'];
  userEmail: Scalars['String'];
  userName: Scalars['String'];
};

export type SetupCompanyPayload = {
  __typename?: 'SetupCompanyPayload';
  tmpPassword: Scalars['String'];
};

export type UpdateApplicationStepConfirmationInput = {
  applicationId: Scalars['Int'];
  applicationStepId: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
  isApproved: Scalars['Boolean'];
  isProxy: Scalars['Boolean'];
};

export type UpdateCompanyAuthMethodInput = {
  isIDPassEnabled: Scalars['Boolean'];
  isSAMLEnabled: Scalars['Boolean'];
};

export type UpdateCompanyRolesInput = {
  companyRoleIds: Array<Scalars['Int']>;
};

export type UpdateCompassRoleInput = {
  roleId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UpdateImportOptoutJobInput = {
  failedError: Scalars['String'];
  jobId: Scalars['String'];
  partFailedAbnormalErrorCount?: InputMaybe<Scalars['Int']>;
  partFailedError?: InputMaybe<Array<InputMaybe<UpdateImportOptoutJobPartFailedError>>>;
  partFailedNormalErrorCount?: InputMaybe<Scalars['Int']>;
  partFailedTotalCount?: InputMaybe<Scalars['Int']>;
  rowCount: Scalars['Int'];
  status: ImportJobStatus;
};

export type UpdateImportOptoutJobPartFailedError = {
  message: Scalars['String'];
  row: Scalars['Int'];
};

export type UpdateInitPasswordInput = {
  name: Scalars['String'];
  password: Scalars['String'];
};

export type UpdateIpRestrictionInput = {
  isIpRestricted: Scalars['Boolean'];
};

export type UpdatePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type UpdateRoomUserConfirmationCodeInput = {
  confirmationCode: Scalars['String'];
};

export type UpdateUserKeywordsInput = {
  keywords: Array<Scalars['String']>;
};

export type UpdateWorksRoleInput = {
  roleId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  companyRoles: Array<CompanyRole>;
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  isResetPassword: Scalars['Boolean'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  projects: Maybe<Array<AssignedProject>>;
  role: WorksRole;
  roleId: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type UserCancelDetail = {
  __typename?: 'UserCancelDetail';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type UserCancelDetailInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type UserCancelDetailUsageCheckResponse = {
  __typename?: 'UserCancelDetailUsageCheckResponse';
  usageDetails: Array<UserCancelDetailUsageDetail>;
};

export type UserCancelDetailUsageDetail = {
  __typename?: 'UserCancelDetailUsageDetail';
  listingName: Scalars['String'];
  usedIn: Array<UserCancelDetailUsedIn>;
};

export enum UserCancelDetailUsedIn {
  AutoShare = 'auto_share',
  PurchaserCancel = 'purchaser_cancel',
  PurchaserSearch = 'purchaser_search'
}

export type UserCancelDetailValidationError = {
  __typename?: 'UserCancelDetailValidationError';
  id: Scalars['Int'];
  listingName: Scalars['String'];
  usedIn: Array<UserCancelDetailUsedIn>;
};

export type UserCancelDetailsResponse = {
  __typename?: 'UserCancelDetailsResponse';
  meta: Meta;
  userCancelDetails: Array<UserCancelDetail>;
};

export type UserIndex = {
  __typename?: 'UserIndex';
  companyRoles: Array<CompanyRole>;
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  isResetPassword: Scalars['Boolean'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  projectCount: Scalars['Int'];
  role: WorksRole;
  roleId: Scalars['Int'];
};

export type UserInput = {
  email: Scalars['String'];
  isInternal: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UserResponse = {
  __typename?: 'UserResponse';
  user: User;
};

export type UserStage = {
  __typename?: 'UserStage';
  id: Scalars['Int'];
  priority: Scalars['Int'];
  stage: Scalars['String'];
  userStageDetails: Array<UserStageDetail>;
};

export type UserStageDetail = {
  __typename?: 'UserStageDetail';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type UserStageDetailInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  userStageId?: InputMaybe<Scalars['Int']>;
};

export type UserStageDetailUsageCheckResponse = {
  __typename?: 'UserStageDetailUsageCheckResponse';
  usageDetails: Array<UserStageDetailUsageDetail>;
};

export type UserStageDetailUsageDetail = {
  __typename?: 'UserStageDetailUsageDetail';
  listingName: Scalars['String'];
  usedIn: Array<UserStageDetailUsedIn>;
};

export enum UserStageDetailUsedIn {
  AutoShare = 'auto_share',
  PurchaserSearch = 'purchaser_search',
  PurchaserStage = 'purchaser_stage'
}

export type UserStageDetailValidationError = {
  __typename?: 'UserStageDetailValidationError';
  id: Scalars['Int'];
  listingName: Scalars['String'];
  usedIn: Array<UserStageDetailUsedIn>;
};

export type UserStageDetailsResponse = {
  __typename?: 'UserStageDetailsResponse';
  meta: Meta;
  userStages: Array<UserStage>;
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  pagination: Pagination;
  users: Maybe<Array<UserIndex>>;
};

export type Wing = {
  __typename?: 'Wing';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type WingDetail = {
  __typename?: 'WingDetail';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  roomCount: Scalars['Int'];
  roomTypes: Array<RoomType>;
};

export type WingInput = {
  id?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  roomTypes?: InputMaybe<Array<InputMaybe<RoomTypeInput>>>;
};

export type WingsResponse = {
  __typename?: 'WingsResponse';
  wings: Array<WingDetail>;
};

export type Workflow = {
  __typename?: 'Workflow';
  id: Scalars['Int'];
  name: Scalars['String'];
  notifiedUserEmailsAnnotation: Maybe<Scalars['String']>;
  type: Scalars['String'];
  workflowSteps: Array<WorkflowStep>;
};

export type WorkflowInput = {
  name: Scalars['String'];
  notifiedUserEmailsAnnotation?: InputMaybe<Scalars['String']>;
  type: WorkflowType;
  workflowSteps: Array<WorkflowStepInput>;
};

export type WorkflowStep = {
  __typename?: 'WorkflowStep';
  id: Scalars['Int'];
  isApproverAddable: Scalars['Boolean'];
  label: Scalars['String'];
  multiApproverCondition: Maybe<Scalars['String']>;
  primaryRoleIds: Array<Scalars['Int']>;
  secondaryRoleIds: Array<Scalars['Int']>;
  stepNumber: Scalars['Int'];
};

export type WorkflowStepInput = {
  IsApproverAddable: Scalars['Boolean'];
  label: Scalars['String'];
  multiApproverCondition?: InputMaybe<Scalars['String']>;
  primaryRoleIds: Array<Scalars['Int']>;
  secondaryRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  stepNumber: Scalars['Int'];
};

export enum WorkflowType {
  Order = 'order',
  Publish = 'publish'
}

export type WorkflowsResponse = {
  __typename?: 'WorkflowsResponse';
  workflows: Array<Workflow>;
};

export type WorksRole = {
  __typename?: 'WorksRole';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CompassRolesResponse = {
  __typename?: 'compassRolesResponse';
  compassRoles: Maybe<Array<CompassRole>>;
};

export enum RoomSourceType {
  Cached = 'cached',
  Diff = 'diff'
}

export type SendSelectEmailsInput = {
  content: SelectEmailContent;
  roomIds: Array<Scalars['Int']>;
};

export type AddExternalUserMutationVariables = Exact<{
  input: AddExternalUserInput;
}>;


export type AddExternalUserMutation = { __typename?: 'Mutation', addExternalUser: boolean | null };

export type AddUserMutationVariables = Exact<{
  input: AddUserInput;
}>;


export type AddUserMutation = { __typename?: 'Mutation', addUser: boolean | null };

export type AssignUserProjectsMutationVariables = Exact<{
  userId: Scalars['Int'];
  input: AssignUserProjectsInput;
}>;


export type AssignUserProjectsMutation = { __typename?: 'Mutation', assignUserProjects: boolean | null };

export type AssignUsersProjectsMutationVariables = Exact<{
  input: AssignUsersProjectsInput;
}>;


export type AssignUsersProjectsMutation = { __typename?: 'Mutation', assignUsersProjects: boolean | null };

export type BulkUpdateRoomsMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: BulkUpdateRoomsInput;
}>;


export type BulkUpdateRoomsMutation = { __typename?: 'Mutation', bulkUpdateRooms: boolean | null };

export type BulkUpdateSelectMastersMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: BulkUpdateSelectMastersInput;
}>;


export type BulkUpdateSelectMastersMutation = { __typename?: 'Mutation', bulkUpdateSelectMasters: boolean | null };

export type BulkUpdateUserStageDetailsMutationVariables = Exact<{
  params: BulkUpdateUserStageDetailsInput;
}>;


export type BulkUpdateUserStageDetailsMutation = { __typename?: 'Mutation', bulkUpdateUserStageDetails: { __typename: 'UserStageDetailsResponse' } };

export type BulkUpdateWingsMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: BulkUpdateWingsInput;
}>;


export type BulkUpdateWingsMutation = { __typename?: 'Mutation', bulkUpdateWings: boolean | null };

export type BulkUpdateUserCancelDetailsMutationVariables = Exact<{
  params: BulkUpdateUserCancelDetailsInput;
}>;


export type BulkUpdateUserCancelDetailsMutation = { __typename?: 'Mutation', bulkUpdateUserCancelDetails: { __typename: 'UserCancelDetailsResponse' } };

export type CancelApplicationMutationVariables = Exact<{
  params: CancelApplicationInput;
}>;


export type CancelApplicationMutation = { __typename?: 'Mutation', cancelApplication: boolean | null };

export type CancelSelectAgreementMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: CancelSelectAgreementInput;
}>;


export type CancelSelectAgreementMutation = { __typename?: 'Mutation', cancelSelectAgreement: boolean | null };

export type CopySelectMasterMutationVariables = Exact<{
  projectId: Scalars['String'];
  selectMasterId: Scalars['Int'];
}>;


export type CopySelectMasterMutation = { __typename?: 'Mutation', copySelectMaster: boolean | null };

export type CreateAllowedIpMutationVariables = Exact<{
  input: AllowedIpInput;
}>;


export type CreateAllowedIpMutation = { __typename?: 'Mutation', createAllowedIp: boolean | null };

export type CreateApplicationMutationVariables = Exact<{
  input: ApplicationInput;
}>;


export type CreateApplicationMutation = { __typename?: 'Mutation', createApplication: { __typename?: 'CreateApplicationPayload', appliedRoomIds: Array<number> } };

export type CreateCommonContentAssetMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  params: CommonAssetInput;
}>;


export type CreateCommonContentAssetMutation = { __typename?: 'Mutation', createCommonAsset: boolean | null };

export type CreateCommonContentPageMutationVariables = Exact<{
  params: CommonPageInput;
}>;


export type CreateCommonContentPageMutation = { __typename?: 'Mutation', createCommonPage: boolean | null };

export type CreateCompanyRoleMutationVariables = Exact<{
  params: CompanyRoleInput;
}>;


export type CreateCompanyRoleMutation = { __typename?: 'Mutation', createCompanyRole: boolean | null };

export type CreateCustomerEmailOptOutCsvPresignedUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCustomerEmailOptOutCsvPresignedUrlMutation = { __typename?: 'Mutation', presignedURLOptoutImport: { __typename?: 'PresignedURLPayload', presignedURL: string, jobId: string, s3URL: string } };

export type CreateProjectMutationVariables = Exact<{
  input: ProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: string | null };

export type CreateRoomUsersCsvPresignedUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateRoomUsersCsvPresignedUrlMutation = { __typename?: 'Mutation', presignedURLRoomUsersImport: { __typename?: 'PresignedURLPayload', presignedURL: string, jobId: string, s3URL: string } };

export type CreateRoomsCsvMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: CreateRoomsCsvInput;
}>;


export type CreateRoomsCsvMutation = { __typename?: 'Mutation', createRoomsCSV: { __typename?: 'CreateRoomsCSVPayload', errorMessage: string, rooms: Array<{ __typename?: 'CreatedRoom', wingName: string, floor: string, roomName: string, roomTypeName: string, selectDisabled: boolean, result: string, message: string }> } | null };

export type CreateSamlIdpMutationVariables = Exact<{
  companyId: Scalars['Int'];
  params: SamlIdpInput;
}>;


export type CreateSamlIdpMutation = { __typename?: 'Mutation', createSAMLIdp: boolean | null };

export type CreateSelectMasterMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: SelectMasterInput;
}>;


export type CreateSelectMasterMutation = { __typename?: 'Mutation', createSelectMaster: boolean | null };

export type CreateWorkflowMutationVariables = Exact<{
  params: WorkflowInput;
}>;


export type CreateWorkflowMutation = { __typename?: 'Mutation', createWorkflow: boolean | null };

export type DeleteAllowedIpMutationVariables = Exact<{
  input: Scalars['Int'];
}>;


export type DeleteAllowedIpMutation = { __typename?: 'Mutation', deleteAllowedIp: boolean | null };

export type DeleteCommonContentAssetMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  commonAssetId: Scalars['Int'];
}>;


export type DeleteCommonContentAssetMutation = { __typename?: 'Mutation', deleteCommonAsset: boolean | null };

export type DeleteCommonContentPageMutationVariables = Exact<{
  CommonPageId: Scalars['Int'];
}>;


export type DeleteCommonContentPageMutation = { __typename?: 'Mutation', deleteCommonPage: boolean | null };

export type DeleteCompanyRoleMutationVariables = Exact<{
  input: Scalars['Int'];
}>;


export type DeleteCompanyRoleMutation = { __typename?: 'Mutation', deleteCompanyRole: boolean | null };

export type DestroyRoomUserMutationVariables = Exact<{
  iamUserId: Scalars['Int'];
  roomId: Scalars['Int'];
}>;


export type DestroyRoomUserMutation = { __typename?: 'Mutation', destroyRoomUser: boolean | null };

export type DeleteCustomerMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: boolean | null };

export type DeleteProjectMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: string | null };

export type DeleteSamlIdpMutationVariables = Exact<{
  companyId: Scalars['Int'];
  identityProviderId: Scalars['Int'];
}>;


export type DeleteSamlIdpMutation = { __typename?: 'Mutation', deleteSAMLIdp: boolean | null };

export type DeleteUserMutationVariables = Exact<{
  input: Scalars['Int'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean | null };

export type ExchangeAuthCodeWithAccessTokenMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type ExchangeAuthCodeWithAccessTokenMutation = { __typename?: 'Mutation', exchangeAuthCodeWithAccessToken: { __typename?: 'AuthPayload', session: { __typename?: 'Session', accessToken: string, refreshToken: string, accessTokenExpiresAt: string, refreshTokenExpiresAt: string, cognitoUsername: string } } | null };

export type ExcludeRoomsFromOrderApplicationMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: ExcludeRoomsFromOrderApplicationInput;
}>;


export type ExcludeRoomsFromOrderApplicationMutation = { __typename?: 'Mutation', excludeRoomsFromOrderApplication: boolean | null };

export type ExcludeRoomsFromPublishApplicationMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: ExcludeRoomsFromPublishApplicationInput;
}>;


export type ExcludeRoomsFromPublishApplicationMutation = { __typename?: 'Mutation', excludeRoomsFromPublishApplication: boolean | null };

export type ForceUpdateExternalUserPasswordMutationVariables = Exact<{
  userId: Scalars['Int'];
  input: ForceUpdatePasswordInput;
}>;


export type ForceUpdateExternalUserPasswordMutation = { __typename?: 'Mutation', forceUpdateExternalUserPassword: boolean | null };

export type ForceUpdateUserPasswordMutationVariables = Exact<{
  userId: Scalars['Int'];
  input: ForceUpdatePasswordInput;
}>;


export type ForceUpdateUserPasswordMutation = { __typename?: 'Mutation', forceUpdateUserPassword: boolean | null };

export type ForgetPasswordEmailMutationVariables = Exact<{
  input: ForgetPasswordInput;
}>;


export type ForgetPasswordEmailMutation = { __typename?: 'Mutation', forgetPassword: boolean | null };

export type IdPassLoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type IdPassLoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', session: { __typename?: 'Session', accessToken: string, refreshToken: string, accessTokenExpiresAt: string, refreshTokenExpiresAt: string, cognitoUsername: string } } | null };

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean | null };

export type NotifyFinishedUploadContractorCsvMutationVariables = Exact<{
  params: ImportRoomUsersInput;
}>;


export type NotifyFinishedUploadContractorCsvMutation = { __typename?: 'Mutation', importRoomUsers: boolean | null };

export type NotifyFinishedUploadCustomerEmailOptOutCsvMutationVariables = Exact<{
  params: ImportOptoutInput;
}>;


export type NotifyFinishedUploadCustomerEmailOptOutCsvMutation = { __typename?: 'Mutation', importOptout: boolean | null };

export type RefreshAuthTokenMutationVariables = Exact<{
  input: RefreshAccessTokenInput;
}>;


export type RefreshAuthTokenMutation = { __typename?: 'Mutation', refreshAccessToken: { __typename?: 'AuthPayload', session: { __typename?: 'Session', accessToken: string, refreshToken: string, accessTokenExpiresAt: string, refreshTokenExpiresAt: string, cognitoUsername: string } } | null };

export type RegisterContractorMutationVariables = Exact<{
  params: RegisterRoomUserInput;
}>;


export type RegisterContractorMutation = { __typename?: 'Mutation', registerRoomUser: boolean | null };

export type RegisterSelectsMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: RegisterSelectsInput;
}>;


export type RegisterSelectsMutation = { __typename?: 'Mutation', registerSelects: boolean | null };

export type ReorderCommonContentAssetsMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  params: ReorderCommonAssetInput;
}>;


export type ReorderCommonContentAssetsMutation = { __typename?: 'Mutation', reorderCommonAssets: boolean | null };

export type ReorderCommonContentPagesMutationVariables = Exact<{
  params: ReorderCommonPageInput;
}>;


export type ReorderCommonContentPagesMutation = { __typename?: 'Mutation', reorderCommonPages: boolean | null };

export type SendSelectEmailMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: SendSelectEmailsInput;
}>;


export type SendSelectEmailMutation = { __typename?: 'Mutation', sendSelectEmails: boolean | null };

export type UpdateAllowedIpMutationVariables = Exact<{
  id: Scalars['Int'];
  input: AllowedIpInput;
}>;


export type UpdateAllowedIpMutation = { __typename?: 'Mutation', updateAllowedIp: boolean | null };

export type UpdateApplicationStepConfirmationMutationVariables = Exact<{
  input: UpdateApplicationStepConfirmationInput;
}>;


export type UpdateApplicationStepConfirmationMutation = { __typename?: 'Mutation', updateApplicationStepConfirmation: boolean | null };

export type UpdateCommonContentAssetMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  commonAssetId: Scalars['Int'];
  params: CommonAssetInput;
}>;


export type UpdateCommonContentAssetMutation = { __typename?: 'Mutation', updateCommonAsset: boolean | null };

export type UpdateCommonContentPageMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  params: CommonPageInput;
}>;


export type UpdateCommonContentPageMutation = { __typename?: 'Mutation', updateCommonPage: boolean | null };

export type UpdateCompanyAuthMethodMutationVariables = Exact<{
  companyId: Scalars['Int'];
  params: UpdateCompanyAuthMethodInput;
}>;


export type UpdateCompanyAuthMethodMutation = { __typename?: 'Mutation', updateCompanyAuthMethod: boolean | null };

export type UpdateCompanyRoleMutationVariables = Exact<{
  roleId: Scalars['Int'];
  params: CompanyRoleInput;
}>;


export type UpdateCompanyRoleMutation = { __typename?: 'Mutation', updateCompanyRole: boolean | null };

export type UpdateRoomUserConfirmationCodeMutationVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
  params: UpdateRoomUserConfirmationCodeInput;
}>;


export type UpdateRoomUserConfirmationCodeMutation = { __typename?: 'Mutation', updateRoomUserConfirmationCode: boolean | null };

export type UpdateExternalUserNameMutationVariables = Exact<{
  userId: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateExternalUserNameMutation = { __typename?: 'Mutation', updateExternalUserName: boolean | null };

export type UpdateInitialPasswordMutationVariables = Exact<{
  input: UpdateInitPasswordInput;
}>;


export type UpdateInitialPasswordMutation = { __typename?: 'Mutation', updateInitPassword: boolean | null };

export type UpdateInternalUserNameMutationVariables = Exact<{
  userId: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateInternalUserNameMutation = { __typename?: 'Mutation', updateInternalUserName: boolean | null };

export type UpdateIpRestrictionMutationVariables = Exact<{
  input: UpdateIpRestrictionInput;
}>;


export type UpdateIpRestrictionMutation = { __typename?: 'Mutation', updateIpRestriction: boolean | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean | null };

export type UpdateProfileNameMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type UpdateProfileNameMutation = { __typename?: 'Mutation', updateProfileName: boolean | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['String'];
  input: ProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: string | null };

export type UpdateProjectShowCommonPageMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: ProjectShowCommonPageInput;
}>;


export type UpdateProjectShowCommonPageMutation = { __typename?: 'Mutation', updateProjectShowCommonPage: boolean | null };

export type UpdateRoomMutationVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
  input: RoomInput;
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom: boolean | null };

export type UpdateSamlIdpMutationVariables = Exact<{
  companyId: Scalars['Int'];
  identityProviderId: Scalars['Int'];
  params: SamlIdpInput;
}>;


export type UpdateSamlIdpMutation = { __typename?: 'Mutation', updateSAMLIdp: boolean | null };

export type UpdateUserCompanyRolesMutationVariables = Exact<{
  userId: Scalars['Int'];
  params: UpdateCompanyRolesInput;
}>;


export type UpdateUserCompanyRolesMutation = { __typename?: 'Mutation', updateUserCompanyRoles: boolean | null };

export type UpdateUserKeywordsMutationVariables = Exact<{
  userId: Scalars['Int'];
  params: UpdateUserKeywordsInput;
}>;


export type UpdateUserKeywordsMutation = { __typename?: 'Mutation', updateUserKeywords: boolean | null };

export type UpdateWorksRoleMutationVariables = Exact<{
  input: UpdateWorksRoleInput;
}>;


export type UpdateWorksRoleMutation = { __typename?: 'Mutation', updateWorksRole: boolean | null };

export type CheckLoginSettingMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckLoginSettingMutation = { __typename?: 'Mutation', checkLoginSetting: { __typename?: 'CheckLoginSettingPayload', isIDPassEnabled: boolean, isSAMLEnabled: boolean, isSuperAdmin: boolean, idpAuthURL: string | null } };

export type CheckUserCancelDetailUsageQueryVariables = Exact<{
  userCancelDetailId: Scalars['Int'];
}>;


export type CheckUserCancelDetailUsageQuery = { __typename?: 'Query', userCancelDetailUsageCheck: { __typename?: 'UserCancelDetailUsageCheckResponse', usageDetails: Array<{ __typename?: 'UserCancelDetailUsageDetail', listingName: string, usedIn: Array<UserCancelDetailUsedIn> }> } };

export type CheckUserStageDetailUsageQueryVariables = Exact<{
  userStageDetailId: Scalars['Int'];
}>;


export type CheckUserStageDetailUsageQuery = { __typename?: 'Query', userStageDetailUsageCheck: { __typename?: 'UserStageDetailUsageCheckResponse', usageDetails: Array<{ __typename?: 'UserStageDetailUsageDetail', listingName: string, usedIn: Array<UserStageDetailUsedIn> }> } };

export type GetAllRoomSelectRegistrationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllRoomSelectRegistrationsQuery = { __typename?: 'Query', allRoomSelectRegistrations: { __typename?: 'RoomSelectRegistrationsResponse', rooms: Array<{ __typename?: 'RoomSelect', id: number, selects: Array<{ __typename?: 'SelectRegistration', id: number, name: string, priority: number, selectMasterId: number, registeredSelectOption: { __typename?: 'RegisteredSelectOption', id: number, name: string, isPaid: boolean, child: { __typename?: 'RegisteredSelectOptionChild', id: number, name: string, isPaid: boolean } | null } | null }> }> } };

export type GetAllowedIpsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllowedIpsQuery = { __typename?: 'Query', allowedIps: { __typename?: 'AllowedIpsResponse', isIpRestricted: boolean, allowedIps: Array<{ __typename?: 'AllowedIp', id: number, ip: string, description: string }> | null } };

export type GetApplicationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetApplicationsQuery = { __typename?: 'Query', applications: { __typename?: 'ApplicationsResponse', applications: Array<{ __typename?: 'Application', id: number, projectId: string, creatorId: number, title: string, status: string, notifiedUserEmails: Array<string>, workflowId: number, comment: string | null, roomIds: Array<number>, canceledRoomIds: Array<number>, isWaitingYourConfirmation: boolean, createdAt: string, applicationSteps: Array<{ __typename?: 'ApplicationStep', id: number, label: string, stepNumber: number, multiApproverCondition: string | null, status: string, dueDate: string, applicationStepConfirmations: Array<{ __typename?: 'ApplicationStepConfirmation', id: number, confirmerId: number, status: string, comment: string | null, confirmedAt: string | null, isProxy: boolean }> }> }> } };

export type GetCachedRoomsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetCachedRoomsQuery = { __typename?: 'Query', cachedRooms: { __typename?: 'RoomsResponse', rooms: Array<{ __typename?: 'Room', id: number, name: string, priority: number, floor: string, wingId: number, wingName: string, roomTypeId: number | null, roomTypeName: string | null, isSelectEnabled: boolean, memo: string | null, selectMasterIds: Array<number>, registrationDueDatetime: string, registrationStatus: SelectRegistrationStatus, publishApplicationStatus: ApplicationStatus, isLocked: boolean, isEnableOrderApplication: boolean, isEnableProxySelectRegistration: boolean, isEnableRoomUserRegistration: boolean, isEnableRoomUserDestroy: boolean, isEnableUpdateConfirmationCode: boolean, isEnableSelectEmailInvitation: boolean, isEnablePublishApplication: boolean, isEnableChangeToUnselectable: boolean, isEnableSelectEmailAgreementRequest: boolean, isEnableCancelSelectAgreement: boolean, isEnableCancelPublishApplication: boolean, isEnableCancelOrderApplication: boolean, isEnableExcludeRoomsFromPublishApplication: boolean, isEnableExcludeRoomsFromOrderApplication: boolean, orderApplicationCanceledAt: string | null, orderApplicationCancelComment: string | null, orderApplicationStatus: ApplicationStatus, adminMemo: string | null, confirmationCode: string | null, source: RoomSourceType, user: { __typename?: 'RoomUser', id: number, name: string, email: string, selectEmailSentTimes: number, agreementRequestEmailSentTimes: number, lastSelectEmailSentAt: string | null, lastAgreementRequestEmailSentAt: string | null, identification: { __typename?: 'Identification', status: IdentificationStatus, code: string | null } } | null }> } };

export type GetCommonPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetCommonPageQuery = { __typename?: 'Query', commonPage: { __typename?: 'CommonPageResponse', id: number, name: string, priority: number, annotation: string | null, meta: { __typename?: 'PageMetaResponse', isPublic: boolean, displayConsumer: boolean, designFormat: string, icon: number }, assets: Array<{ __typename?: 'Asset', id: number, name: string, category: string, priority: number, fileSize: number, externalLink: string, meta: { __typename?: 'AssetMeta', fileName: string | null, uploadedAt: number, UploadedWorksUserBy: number }, data: { __typename?: 'AssetData', url: string, thumbUrl: string } }> } };

export type GetCommonPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommonPagesQuery = { __typename?: 'Query', commonPages: { __typename?: 'CommonPagesResponse', commonPages: Array<{ __typename?: 'CommonPageResponse', id: number, name: string, priority: number, annotation: string | null, meta: { __typename?: 'PageMetaResponse', isPublic: boolean, displayConsumer: boolean, designFormat: string, icon: number }, assets: Array<{ __typename?: 'Asset', id: number, name: string, category: string, priority: number, fileSize: number, externalLink: string, meta: { __typename?: 'AssetMeta', fileName: string | null, uploadedAt: number, UploadedWorksUserBy: number }, data: { __typename?: 'AssetData', url: string, thumbUrl: string } }> }> } };

export type GetCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyQuery = { __typename?: 'Query', company: { __typename?: 'CompanyResponse', id: number, name: string, isIDPassEnabled: boolean, isSAMLEnabled: boolean } };

export type CompanyRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyRolesQuery = { __typename?: 'Query', companyRoles: { __typename?: 'CompanyRolesResponse', roles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number>, users: Array<{ __typename?: 'UserIndex', id: number, name: string | null }> }> | null } };

export type GetCompassRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompassRolesQuery = { __typename?: 'Query', compassRoles: { __typename?: 'compassRolesResponse', compassRoles: Array<{ __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }> | null } };

export type GetCustomerProjectsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetCustomerProjectsQuery = { __typename?: 'Query', customerProjects: { __typename?: 'CustomerProjectsResponse', customerProjects: Array<{ __typename?: 'CustomerProject', id: string, title: string, projectCustomerName: string | null, createdAt: string, currentSignInAt: string | null, inviterName: string | null, isRoomIamUser: boolean, roomNames: Array<string | null> }> } };

export type GetDiffRoomsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetDiffRoomsQuery = { __typename?: 'Query', diffRooms: { __typename?: 'DiffRoomsResponse', rooms: Array<{ __typename?: 'DiffRoom', type: DiffType, room: { __typename?: 'Room', id: number, name: string, priority: number, floor: string, wingId: number, wingName: string, roomTypeId: number | null, roomTypeName: string | null, isSelectEnabled: boolean, memo: string | null, selectMasterIds: Array<number>, registrationDueDatetime: string, registrationStatus: SelectRegistrationStatus, publishApplicationStatus: ApplicationStatus, isLocked: boolean, isEnableOrderApplication: boolean, isEnableProxySelectRegistration: boolean, isEnableRoomUserRegistration: boolean, isEnableRoomUserDestroy: boolean, isEnableUpdateConfirmationCode: boolean, isEnableSelectEmailInvitation: boolean, isEnablePublishApplication: boolean, isEnableChangeToUnselectable: boolean, isEnableSelectEmailAgreementRequest: boolean, isEnableCancelSelectAgreement: boolean, isEnableCancelPublishApplication: boolean, isEnableCancelOrderApplication: boolean, isEnableExcludeRoomsFromPublishApplication: boolean, isEnableExcludeRoomsFromOrderApplication: boolean, orderApplicationCanceledAt: string | null, orderApplicationCancelComment: string | null, orderApplicationStatus: ApplicationStatus, adminMemo: string | null, confirmationCode: string | null, source: RoomSourceType, user: { __typename?: 'RoomUser', id: number, name: string, email: string, selectEmailSentTimes: number, agreementRequestEmailSentTimes: number, lastSelectEmailSentAt: string | null, lastAgreementRequestEmailSentAt: string | null, identification: { __typename?: 'Identification', status: IdentificationStatus, code: string | null } } | null } }> } };

export type GetEmailDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailDomainsQuery = { __typename?: 'Query', emailDomains: { __typename?: 'EmailDomainsResponse', emailDomains: Array<{ __typename?: 'EmailDomain', id: number, allowedDomain: string } | null> } };

export type GetExternalUserQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetExternalUserQuery = { __typename?: 'Query', externalUser: { __typename?: 'ExternalUserResponse', user: { __typename?: 'ExternalUser', id: number, name: string | null, email: string, keywords: Array<string>, createdAt: string, updatedAt: string, projects: Array<{ __typename?: 'AssignedProject', id: string, title: string, adminUrl: string, presentationUrl: string, isDeleting: boolean, isWorksManaged: boolean, assignedAt: string, role: { __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number } }> | null } } };

export type GetExternalUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalUsersQuery = { __typename?: 'Query', externalUsers: { __typename?: 'ExternalUsersResponse', users: Array<{ __typename?: 'ExternalUserIndex', id: number, email: string, name: string | null, keywords: Array<string>, createdAt: string, projectCount: number }> | null, pagination: { __typename?: 'Pagination', current: number, previous: number, next: number, limitValue: number, pageCount: number, totalCount: number } } };

export type GetGroupingRoomsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetGroupingRoomsQuery = { __typename?: 'Query', groupingRooms: { __typename?: 'GroupingRoomsResponse', rooms: Array<{ __typename?: 'GroupingRoom', id: number, groupingKey: string }> } };

export type GetLatestImportOptOutJobQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestImportOptOutJobQuery = { __typename?: 'Query', latestImportOptoutJob: { __typename?: 'ImportOptoutJobResponse', jobId: string, status: ImportJobStatus, rowCount: number, failedError: string | null, updatedAt: string, partFailedTotalCount: number | null, partFailedNormalErrorCount: number | null, partFailedAbnormalErrorCount: number | null, partFailedError: Array<{ __typename?: 'ImportOptoutJobPartFailedError', row: number, message: string }> | null } };

export type GetLatestImportRoomUsersJobQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestImportRoomUsersJobQuery = { __typename?: 'Query', latestImportRoomUsersJob: { __typename?: 'ImportRoomUsersJobResponse', jobId: string, status: ImportJobStatus, lineCount: number, updatedAt: string, errorMessage: string | null, errorReportS3Url: string | null, errorDetails: Array<{ __typename?: 'ImportRoomUsersJobErrorDetail', line: number, message: string }> | null } };

export type GetMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterDataQuery = { __typename?: 'Query', masterData: { __typename?: 'MasterDataResponse', worksRoles: Array<{ __typename?: 'WorksRole', id: number, name: string, displayName: string } | null> | null, companyPolicies: Array<{ __typename?: 'CompanyPolicy', id: number, name: string, displayName: string } | null> | null } };

export type GetMyReviewingConfirmationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyReviewingConfirmationsQuery = { __typename?: 'Query', myReviewingConfirmations: { __typename?: 'MyReviewingConfirmationsResponse', confirmations: Array<{ __typename?: 'MyReviewingConfirmation', id: number, applicationId: number, projectId: string, projectName: string, applicationWorkflowName: string, applicationType: ApplicationType, applicationTitle: string, applicationCreatorId: number, applicationCreatedAt: string, dueDate: string }> } };

export type GetOgpImageQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type GetOgpImageQuery = { __typename?: 'Query', ogpImage: { __typename?: 'OgpImageResponse', url: string } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'ProfileResponse', user: { __typename?: 'ProfileUser', id: number, name: string | null, email: string, roleId: number, isResetPassword: boolean, keywords: Array<string>, policies: Array<string> | null, createdAt: string, updatedAt: string, role: { __typename?: 'WorksRole', id: number, name: string, displayName: string }, projects: Array<{ __typename?: 'AssignedProject', id: string, title: string, adminUrl: string, presentationUrl: string, isDeleting: boolean, isWorksManaged: boolean, assignedAt: string, role: { __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number } }> | null, companyRoles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number> }> | null, companyPolicies: Array<{ __typename?: 'CompanyPolicy', id: number, name: string, displayName: string }> | null } } };

export type GetProjectQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project: { __typename?: 'ProjectResponse', project: { __typename?: 'Project', id: string, title: string, code: string | null, zipcode: string | null, prefecture: string, city: string | null, address: string | null, structureCount: number | null, roomCount: number | null, planCount: number | null, averagePriceRange: number | null, purchaserCount: number | null, applicationCount: number | null, totalPvCount: number, totalSessionCount: number, email: string | null, emailDisplayName: string | null, adminUrl: string, presentationUrl: string, isWorksManaged: boolean, showCommonPage: boolean, isDeleting: boolean, createdAt: string, updatedAt: string, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number }, users: Array<{ __typename?: 'AssingedUser', id: number, name: string | null, email: string, isExternal: boolean, assignedAt: string, keywords: Array<string>, role: { __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }, companyRoles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number> }> }> | null, mainContents: Array<{ __typename?: 'MainContent', id: number, name: string }> | null } } };

export type GetProjectStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectStatusesQuery = { __typename?: 'Query', projectStatuses: { __typename?: 'ProjectStatusesResponse', projectStatuses: Array<{ __typename?: 'ProjectStatus', name: string, displayName: string, priority: number }> } };

export type GetProjectSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectSummaryQuery = { __typename?: 'Query', projectSummary: { __typename?: 'ProjectSummaryResponse', projectCountHistories: Array<{ __typename?: 'ProjectCountHistory', month: string, activatedCount: number }> | null } };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectsResponse', projects: Array<{ __typename?: 'ProjectIndex', id: string, title: string, code: string | null, prefecture: string, structureCount: number | null, roomCount: number | null, planCount: number | null, averagePriceRange: number | null, purchaserCount: number | null, applicationCount: number | null, adminUrl: string, presentationUrl: string, isWorksManaged: boolean, isDeleting: boolean, createdAt: string, updatedAt: string, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number }, creator: { __typename?: 'Creator', id: number, name: string } }> | null, pagination: { __typename?: 'Pagination', current: number, previous: number, next: number, limitValue: number, pageCount: number, totalCount: number } } };

export type GetRoomSelectMastersQueryVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
}>;


export type GetRoomSelectMastersQuery = { __typename?: 'Query', roomSelectMasters: { __typename?: 'RoomSelectMastersResponse', selectMasters: Array<{ __typename?: 'RoomSelectMaster', id: number, selectOptionMasterIds: Array<number> }> } };

export type GetRoomSelectRegistrationsQueryVariables = Exact<{
  projectId: Scalars['String'];
  roomIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetRoomSelectRegistrationsQuery = { __typename?: 'Query', roomSelectRegistrations: { __typename?: 'RoomSelectRegistrationsResponse', rooms: Array<{ __typename?: 'RoomSelect', id: number, selects: Array<{ __typename?: 'SelectRegistration', id: number, name: string, priority: number, selectMasterId: number, registeredSelectOption: { __typename?: 'RegisteredSelectOption', id: number, name: string, isPaid: boolean, child: { __typename?: 'RegisteredSelectOptionChild', id: number, name: string, isPaid: boolean } | null } | null }> }> } };

export type GetRoomTypesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetRoomTypesQuery = { __typename?: 'Query', roomTypes: { __typename?: 'RoomTypesResponse', roomTypes: Array<{ __typename?: 'RoomType', id: number, name: string, priority: number, worksRoomIds: Array<number> | null, compassRoomCount: number }> } };

export type GetRoomsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetRoomsQuery = { __typename?: 'Query', rooms: { __typename?: 'RoomsResponse', rooms: Array<{ __typename?: 'Room', id: number, name: string, priority: number, floor: string, wingId: number, wingName: string, roomTypeId: number | null, roomTypeName: string | null, isSelectEnabled: boolean, memo: string | null, selectMasterIds: Array<number>, registrationDueDatetime: string, registrationStatus: SelectRegistrationStatus, publishApplicationStatus: ApplicationStatus, isLocked: boolean, isEnableOrderApplication: boolean, isEnableProxySelectRegistration: boolean, isEnableRoomUserRegistration: boolean, isEnableRoomUserDestroy: boolean, isEnableUpdateConfirmationCode: boolean, isEnableSelectEmailInvitation: boolean, isEnablePublishApplication: boolean, isEnableChangeToUnselectable: boolean, isEnableSelectEmailAgreementRequest: boolean, isEnableCancelSelectAgreement: boolean, isEnableCancelPublishApplication: boolean, isEnableCancelOrderApplication: boolean, isEnableExcludeRoomsFromPublishApplication: boolean, isEnableExcludeRoomsFromOrderApplication: boolean, orderApplicationCanceledAt: string | null, orderApplicationCancelComment: string | null, orderApplicationStatus: ApplicationStatus, adminMemo: string | null, confirmationCode: string | null, user: { __typename?: 'RoomUser', id: number, name: string, email: string, selectEmailSentTimes: number, agreementRequestEmailSentTimes: number, lastSelectEmailSentAt: string | null, lastAgreementRequestEmailSentAt: string | null, identification: { __typename?: 'Identification', status: IdentificationStatus, code: string | null } } | null }> } };

export type SamlIdpQueryVariables = Exact<{ [key: string]: never; }>;


export type SamlIdpQuery = { __typename?: 'Query', samlIdp: { __typename?: 'SAMLIdpResponse', assertionConsumerServiceURL: string, serviceProviderURN: string, samlIdp: { __typename?: 'SAMLIdp', id: number, idpSignout: boolean, metadataFile: string | null, metadataFileName: string | null, metadataURL: string | null, attributeMapping: { __typename?: 'AttributeMapping', email: string, name: string | null, department: string | null } } | null } };

export type GetContractorHistoriesQueryVariables = Exact<{
  roomId: Scalars['Int'];
}>;


export type GetContractorHistoriesQuery = { __typename?: 'Query', selectContractorHistories: { __typename?: 'SelectContractorHistoriesResponse', histories: Array<{ __typename?: 'SelectContractorHistory', timestamp: string, action: string, actor: { __typename?: 'ContractorHistoryActor', id: number, name: string | null, type: ContractorHistoryActorType, companyRoleNames: Array<string> | null } | null }> } };

export type GetSelectMastersQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSelectMastersQuery = { __typename?: 'Query', selectMasters: { __typename?: 'SelectMastersResponse', selectMasters: Array<{ __typename?: 'SelectMaster', id: number, name: string, priority: number, displayName: string, description: string | null, modelRoomInfo: string | null, annotation: string | null, fileName: string | null, isPlanSelect: boolean, roomIds: Array<number>, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null, assignments: { __typename?: 'SelectMasterAssignments', mainContents: Array<number> | null } | null, selectOptionMasters: Array<{ __typename?: 'SelectOptionMaster', id: number, name: string, annotation: string | null, isPaid: boolean, priority: number, fileName: string | null, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null, children: Array<{ __typename?: 'SelectOptionMaster', id: number, name: string, annotation: string | null, isPaid: boolean, priority: number, fileName: string | null, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null }> | null }> }> | null } };

export type GetSelectRegistrationsQueryVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
}>;


export type GetSelectRegistrationsQuery = { __typename?: 'Query', selectRegistrations: { __typename?: 'SelectRegistrationsResponse', selectRegistrations: Array<{ __typename?: 'SelectRegistration', id: number, name: string, priority: number, selectMasterId: number, registeredSelectOption: { __typename?: 'RegisteredSelectOption', id: number, name: string, isPaid: boolean, child: { __typename?: 'RegisteredSelectOptionChild', id: number, name: string, isPaid: boolean } | null } | null }> } };

export type GetSelectsQueryVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
}>;


export type GetSelectsQuery = { __typename?: 'Query', selects: { __typename?: 'SelectsResponse', selects: Array<{ __typename?: 'Select', id: number, priority: number, name: string, displayName: string, description: string, modelRoomInfo: string, annotation: string, selectMasterId: number, isPlanSelect: boolean, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null, assignments: { __typename?: 'SelectMasterAssignments', mainContents: Array<number> | null } | null, selectOptions: Array<{ __typename?: 'SelectOption', id: number, name: string, annotation: string, isPaid: boolean, priority: number, isSelected: boolean, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null, children: Array<{ __typename?: 'SelectOption', id: number, name: string, annotation: string, isPaid: boolean, priority: number, isSelected: boolean, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null }> | null }> }> } };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'UserResponse', user: { __typename?: 'User', id: number, name: string | null, email: string, roleId: number, isResetPassword: boolean, keywords: Array<string>, createdAt: string, updatedAt: string, role: { __typename?: 'WorksRole', id: number, name: string, displayName: string }, projects: Array<{ __typename?: 'AssignedProject', id: string, title: string, adminUrl: string, presentationUrl: string, isDeleting: boolean, isWorksManaged: boolean, assignedAt: string, role: { __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number } }> | null, companyRoles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number> }> } } };

export type GetUserCancelDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCancelDetailsQuery = { __typename?: 'Query', userCancelDetails: { __typename?: 'UserCancelDetailsResponse', userCancelDetails: Array<{ __typename?: 'UserCancelDetail', id: number, name: string, priority: number }>, meta: { __typename?: 'Meta', updatedAt: string, createdAt: string, updatedBy: { __typename?: 'Editor', id: number, name: string }, createdBy: { __typename?: 'Editor', id: number, name: string } } } };

export type UserStageDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserStageDetailsQuery = { __typename?: 'Query', userStageDetails: { __typename?: 'UserStageDetailsResponse', userStages: Array<{ __typename?: 'UserStage', id: number, stage: string, priority: number, userStageDetails: Array<{ __typename?: 'UserStageDetail', id: number, name: string, priority: number }> }>, meta: { __typename?: 'Meta', updatedAt: string, createdAt: string, updatedBy: { __typename?: 'Editor', id: number, name: string }, createdBy: { __typename?: 'Editor', id: number, name: string } } } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResponse', users: Array<{ __typename?: 'UserIndex', id: number, name: string | null, email: string, keywords: Array<string>, roleId: number, isResetPassword: boolean, projectCount: number, createdAt: string, role: { __typename?: 'WorksRole', id: number, name: string, displayName: string }, companyRoles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number> }> }> | null } };

export type GetWingsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetWingsQuery = { __typename?: 'Query', wings: { __typename?: 'WingsResponse', wings: Array<{ __typename?: 'WingDetail', id: number, name: string, roomCount: number, priority: number, roomTypes: Array<{ __typename?: 'RoomType', id: number, name: string, priority: number, worksRoomIds: Array<number> | null, compassRoomCount: number }> }> } };

export type GetWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowsQuery = { __typename?: 'Query', workflows: { __typename?: 'WorkflowsResponse', workflows: Array<{ __typename?: 'Workflow', id: number, name: string, type: string, notifiedUserEmailsAnnotation: string | null, workflowSteps: Array<{ __typename?: 'WorkflowStep', id: number, label: string, stepNumber: number, primaryRoleIds: Array<number>, secondaryRoleIds: Array<number>, isApproverAddable: boolean, multiApproverCondition: string | null }> }> } };


export const AddExternalUserDocument = gql`
    mutation addExternalUser($input: AddExternalUserInput!) {
  addExternalUser(params: $input)
}
    `;
export const AddUserDocument = gql`
    mutation addUser($input: AddUserInput!) {
  addUser(params: $input)
}
    `;
export const AssignUserProjectsDocument = gql`
    mutation AssignUserProjects($userId: Int!, $input: AssignUserProjectsInput!) {
  assignUserProjects(userId: $userId, params: $input)
}
    `;
export const AssignUsersProjectsDocument = gql`
    mutation AssignUsersProjects($input: AssignUsersProjectsInput!) {
  assignUsersProjects(params: $input)
}
    `;
export const BulkUpdateRoomsDocument = gql`
    mutation bulkUpdateRooms($projectId: String!, $params: BulkUpdateRoomsInput!) {
  bulkUpdateRooms(projectId: $projectId, params: $params)
}
    `;
export const BulkUpdateSelectMastersDocument = gql`
    mutation bulkUpdateSelectMasters($projectId: String!, $params: BulkUpdateSelectMastersInput!) {
  bulkUpdateSelectMasters(projectId: $projectId, params: $params)
}
    `;
export const BulkUpdateUserStageDetailsDocument = gql`
    mutation BulkUpdateUserStageDetails($params: BulkUpdateUserStageDetailsInput!) {
  bulkUpdateUserStageDetails(params: $params) {
    __typename
  }
}
    `;
export const BulkUpdateWingsDocument = gql`
    mutation bulkUpdateWings($projectId: String!, $params: BulkUpdateWingsInput!) {
  bulkUpdateWings(projectId: $projectId, params: $params)
}
    `;
export const BulkUpdateUserCancelDetailsDocument = gql`
    mutation bulkUpdateUserCancelDetails($params: BulkUpdateUserCancelDetailsInput!) {
  bulkUpdateUserCancelDetails(params: $params) {
    __typename
  }
}
    `;
export const CancelApplicationDocument = gql`
    mutation cancelApplication($params: CancelApplicationInput!) {
  cancelApplication(params: $params)
}
    `;
export const CancelSelectAgreementDocument = gql`
    mutation cancelSelectAgreement($projectId: String!, $params: CancelSelectAgreementInput!) {
  cancelSelectAgreement(projectId: $projectId, params: $params)
}
    `;
export const CopySelectMasterDocument = gql`
    mutation copySelectMaster($projectId: String!, $selectMasterId: Int!) {
  copySelectMaster(projectId: $projectId, selectMasterId: $selectMasterId)
}
    `;
export const CreateAllowedIpDocument = gql`
    mutation createAllowedIp($input: AllowedIpInput!) {
  createAllowedIp(params: $input)
}
    `;
export const CreateApplicationDocument = gql`
    mutation createApplication($input: ApplicationInput!) {
  createApplication(params: $input) {
    appliedRoomIds
  }
}
    `;
export const CreateCommonContentAssetDocument = gql`
    mutation CreateCommonContentAsset($commonPageId: Int!, $params: CommonAssetInput!) {
  createCommonAsset(commonPageId: $commonPageId, params: $params)
}
    `;
export const CreateCommonContentPageDocument = gql`
    mutation CreateCommonContentPage($params: CommonPageInput!) {
  createCommonPage(params: $params)
}
    `;
export const CreateCompanyRoleDocument = gql`
    mutation CreateCompanyRole($params: CompanyRoleInput!) {
  createCompanyRole(params: $params)
}
    `;
export const CreateCustomerEmailOptOutCsvPresignedUrlDocument = gql`
    mutation createCustomerEmailOptOutCsvPresignedUrl {
  presignedURLOptoutImport {
    presignedURL
    jobId
    s3URL
  }
}
    `;
export const CreateProjectDocument = gql`
    mutation createProject($input: ProjectInput!) {
  createProject(params: $input)
}
    `;
export const CreateRoomUsersCsvPresignedUrlDocument = gql`
    mutation createRoomUsersCsvPresignedUrl {
  presignedURLRoomUsersImport {
    presignedURL
    jobId
    s3URL
  }
}
    `;
export const CreateRoomsCsvDocument = gql`
    mutation createRoomsCSV($projectId: String!, $params: CreateRoomsCSVInput!) {
  createRoomsCSV(projectId: $projectId, params: $params) {
    rooms {
      wingName
      floor
      roomName
      roomTypeName
      selectDisabled
      result
      message
    }
    errorMessage
  }
}
    `;
export const CreateSamlIdpDocument = gql`
    mutation createSAMLIdp($companyId: Int!, $params: SAMLIdpInput!) {
  createSAMLIdp(companyId: $companyId, params: $params)
}
    `;
export const CreateSelectMasterDocument = gql`
    mutation CreateSelectMaster($projectId: String!, $params: SelectMasterInput!) {
  createSelectMaster(projectId: $projectId, params: $params)
}
    `;
export const CreateWorkflowDocument = gql`
    mutation createWorkflow($params: WorkflowInput!) {
  createWorkflow(params: $params)
}
    `;
export const DeleteAllowedIpDocument = gql`
    mutation deleteAllowedIp($input: Int!) {
  deleteAllowedIp(allowedIpId: $input)
}
    `;
export const DeleteCommonContentAssetDocument = gql`
    mutation DeleteCommonContentAsset($commonPageId: Int!, $commonAssetId: Int!) {
  deleteCommonAsset(commonPageId: $commonPageId, commonAssetId: $commonAssetId)
}
    `;
export const DeleteCommonContentPageDocument = gql`
    mutation DeleteCommonContentPage($CommonPageId: Int!) {
  deleteCommonPage(commonPageId: $CommonPageId)
}
    `;
export const DeleteCompanyRoleDocument = gql`
    mutation deleteCompanyRole($input: Int!) {
  deleteCompanyRole(roleId: $input)
}
    `;
export const DestroyRoomUserDocument = gql`
    mutation destroyRoomUser($iamUserId: Int!, $roomId: Int!) {
  destroyRoomUser(iamUserId: $iamUserId, roomId: $roomId)
}
    `;
export const DeleteCustomerDocument = gql`
    mutation deleteCustomer($email: String!) {
  deleteCustomer(email: $email)
}
    `;
export const DeleteProjectDocument = gql`
    mutation deleteProject($projectId: String!) {
  deleteProject(projectId: $projectId)
}
    `;
export const DeleteSamlIdpDocument = gql`
    mutation deleteSAMLIdp($companyId: Int!, $identityProviderId: Int!) {
  deleteSAMLIdp(companyId: $companyId, identityProviderId: $identityProviderId)
}
    `;
export const DeleteUserDocument = gql`
    mutation deleteUser($input: Int!) {
  deleteUser(userId: $input)
}
    `;
export const ExchangeAuthCodeWithAccessTokenDocument = gql`
    mutation exchangeAuthCodeWithAccessToken($code: String!) {
  exchangeAuthCodeWithAccessToken(code: $code) {
    session {
      accessToken
      refreshToken
      accessTokenExpiresAt
      refreshTokenExpiresAt
      cognitoUsername
    }
  }
}
    `;
export const ExcludeRoomsFromOrderApplicationDocument = gql`
    mutation excludeRoomsFromOrderApplication($projectId: String!, $params: ExcludeRoomsFromOrderApplicationInput!) {
  excludeRoomsFromOrderApplication(projectId: $projectId, params: $params)
}
    `;
export const ExcludeRoomsFromPublishApplicationDocument = gql`
    mutation excludeRoomsFromPublishApplication($projectId: String!, $params: ExcludeRoomsFromPublishApplicationInput!) {
  excludeRoomsFromPublishApplication(projectId: $projectId, params: $params)
}
    `;
export const ForceUpdateExternalUserPasswordDocument = gql`
    mutation forceUpdateExternalUserPassword($userId: Int!, $input: ForceUpdatePasswordInput!) {
  forceUpdateExternalUserPassword(userId: $userId, params: $input)
}
    `;
export const ForceUpdateUserPasswordDocument = gql`
    mutation forceUpdateUserPassword($userId: Int!, $input: ForceUpdatePasswordInput!) {
  forceUpdateUserPassword(userId: $userId, params: $input)
}
    `;
export const ForgetPasswordEmailDocument = gql`
    mutation forgetPasswordEmail($input: ForgetPasswordInput!) {
  forgetPassword(params: $input)
}
    `;
export const IdPassLoginDocument = gql`
    mutation idPassLogin($input: LoginInput!) {
  login(params: $input) {
    session {
      accessToken
      refreshToken
      accessTokenExpiresAt
      refreshTokenExpiresAt
      cognitoUsername
    }
  }
}
    `;
export const LogoutDocument = gql`
    mutation logout($input: LogoutInput!) {
  logout(params: $input)
}
    `;
export const NotifyFinishedUploadContractorCsvDocument = gql`
    mutation notifyFinishedUploadContractorCsv($params: ImportRoomUsersInput!) {
  importRoomUsers(params: $params)
}
    `;
export const NotifyFinishedUploadCustomerEmailOptOutCsvDocument = gql`
    mutation notifyFinishedUploadCustomerEmailOptOutCsv($params: ImportOptoutInput!) {
  importOptout(params: $params)
}
    `;
export const RefreshAuthTokenDocument = gql`
    mutation refreshAuthToken($input: RefreshAccessTokenInput!) {
  refreshAccessToken(params: $input) {
    session {
      accessToken
      refreshToken
      accessTokenExpiresAt
      refreshTokenExpiresAt
      cognitoUsername
    }
  }
}
    `;
export const RegisterContractorDocument = gql`
    mutation registerContractor($params: RegisterRoomUserInput!) {
  registerRoomUser(params: $params)
}
    `;
export const RegisterSelectsDocument = gql`
    mutation registerSelects($projectId: String!, $input: RegisterSelectsInput!) {
  registerSelects(projectId: $projectId, params: $input)
}
    `;
export const ReorderCommonContentAssetsDocument = gql`
    mutation ReorderCommonContentAssets($commonPageId: Int!, $params: ReorderCommonAssetInput!) {
  reorderCommonAssets(commonPageId: $commonPageId, params: $params)
}
    `;
export const ReorderCommonContentPagesDocument = gql`
    mutation ReorderCommonContentPages($params: ReorderCommonPageInput!) {
  reorderCommonPages(params: $params)
}
    `;
export const SendSelectEmailDocument = gql`
    mutation sendSelectEmail($projectId: String!, $input: sendSelectEmailsInput!) {
  sendSelectEmails(projectId: $projectId, params: $input)
}
    `;
export const UpdateAllowedIpDocument = gql`
    mutation updateAllowedIp($id: Int!, $input: AllowedIpInput!) {
  updateAllowedIp(allowedIpId: $id, params: $input)
}
    `;
export const UpdateApplicationStepConfirmationDocument = gql`
    mutation updateApplicationStepConfirmation($input: UpdateApplicationStepConfirmationInput!) {
  updateApplicationStepConfirmation(params: $input)
}
    `;
export const UpdateCommonContentAssetDocument = gql`
    mutation UpdateCommonContentAsset($commonPageId: Int!, $commonAssetId: Int!, $params: CommonAssetInput!) {
  updateCommonAsset(
    commonPageId: $commonPageId
    commonAssetId: $commonAssetId
    params: $params
  )
}
    `;
export const UpdateCommonContentPageDocument = gql`
    mutation UpdateCommonContentPage($commonPageId: Int!, $params: CommonPageInput!) {
  updateCommonPage(commonPageId: $commonPageId, params: $params)
}
    `;
export const UpdateCompanyAuthMethodDocument = gql`
    mutation updateCompanyAuthMethod($companyId: Int!, $params: UpdateCompanyAuthMethodInput!) {
  updateCompanyAuthMethod(companyId: $companyId, params: $params)
}
    `;
export const UpdateCompanyRoleDocument = gql`
    mutation UpdateCompanyRole($roleId: Int!, $params: CompanyRoleInput!) {
  updateCompanyRole(roleId: $roleId, params: $params)
}
    `;
export const UpdateRoomUserConfirmationCodeDocument = gql`
    mutation updateRoomUserConfirmationCode($projectId: String!, $roomId: Int!, $params: UpdateRoomUserConfirmationCodeInput!) {
  updateRoomUserConfirmationCode(
    projectId: $projectId
    roomId: $roomId
    params: $params
  )
}
    `;
export const UpdateExternalUserNameDocument = gql`
    mutation UpdateExternalUserName($userId: Int!, $name: String!) {
  updateExternalUserName(userId: $userId, name: $name)
}
    `;
export const UpdateInitialPasswordDocument = gql`
    mutation updateInitialPassword($input: UpdateInitPasswordInput!) {
  updateInitPassword(params: $input)
}
    `;
export const UpdateInternalUserNameDocument = gql`
    mutation UpdateInternalUserName($userId: Int!, $name: String!) {
  updateInternalUserName(userId: $userId, name: $name)
}
    `;
export const UpdateIpRestrictionDocument = gql`
    mutation updateIpRestriction($input: UpdateIpRestrictionInput!) {
  updateIpRestriction(params: $input)
}
    `;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($input: UpdatePasswordInput!) {
  updatePassword(params: $input)
}
    `;
export const UpdateProfileNameDocument = gql`
    mutation updateProfileName($input: String!) {
  updateProfileName(name: $input)
}
    `;
export const UpdateProjectDocument = gql`
    mutation updateProject($id: String!, $input: ProjectInput!) {
  updateProject(projectId: $id, params: $input)
}
    `;
export const UpdateProjectShowCommonPageDocument = gql`
    mutation updateProjectShowCommonPage($projectId: String!, $params: ProjectShowCommonPageInput!) {
  updateProjectShowCommonPage(projectId: $projectId, params: $params)
}
    `;
export const UpdateRoomDocument = gql`
    mutation updateRoom($projectId: String!, $roomId: Int!, $input: RoomInput!) {
  updateRoom(projectId: $projectId, roomId: $roomId, params: $input)
}
    `;
export const UpdateSamlIdpDocument = gql`
    mutation updateSAMLIdp($companyId: Int!, $identityProviderId: Int!, $params: SAMLIdpInput!) {
  updateSAMLIdp(
    companyId: $companyId
    identityProviderId: $identityProviderId
    params: $params
  )
}
    `;
export const UpdateUserCompanyRolesDocument = gql`
    mutation UpdateUserCompanyRoles($userId: Int!, $params: UpdateCompanyRolesInput!) {
  updateUserCompanyRoles(userId: $userId, params: $params)
}
    `;
export const UpdateUserKeywordsDocument = gql`
    mutation UpdateUserKeywords($userId: Int!, $params: UpdateUserKeywordsInput!) {
  updateUserKeywords(userId: $userId, params: $params)
}
    `;
export const UpdateWorksRoleDocument = gql`
    mutation updateWorksRole($input: UpdateWorksRoleInput!) {
  updateWorksRole(params: $input)
}
    `;
export const CheckLoginSettingDocument = gql`
    mutation checkLoginSetting($email: String!) {
  checkLoginSetting(email: $email) {
    isIDPassEnabled
    isSAMLEnabled
    isSuperAdmin
    idpAuthURL
  }
}
    `;
export const CheckUserCancelDetailUsageDocument = gql`
    query checkUserCancelDetailUsage($userCancelDetailId: Int!) {
  userCancelDetailUsageCheck(userCancelDetailId: $userCancelDetailId) {
    usageDetails {
      listingName
      usedIn
    }
  }
}
    `;
export const CheckUserStageDetailUsageDocument = gql`
    query checkUserStageDetailUsage($userStageDetailId: Int!) {
  userStageDetailUsageCheck(userStageDetailId: $userStageDetailId) {
    usageDetails {
      listingName
      usedIn
    }
  }
}
    `;
export const GetAllRoomSelectRegistrationsDocument = gql`
    query getAllRoomSelectRegistrations($projectId: String!) {
  allRoomSelectRegistrations(projectId: $projectId) {
    rooms {
      id
      selects {
        id
        name
        priority
        selectMasterId
        registeredSelectOption {
          id
          name
          isPaid
          child {
            id
            name
            isPaid
          }
        }
      }
    }
  }
}
    `;
export const GetAllowedIpsDocument = gql`
    query getAllowedIps {
  allowedIps {
    isIpRestricted
    allowedIps {
      id
      ip
      description
    }
  }
}
    `;
export const GetApplicationsDocument = gql`
    query getApplications($projectId: String!) {
  applications(projectId: $projectId) {
    applications {
      id
      projectId
      creatorId
      title
      status
      notifiedUserEmails
      workflowId
      applicationSteps {
        id
        label
        stepNumber
        multiApproverCondition
        status
        dueDate
        applicationStepConfirmations {
          id
          confirmerId
          status
          comment
          confirmedAt
          isProxy
        }
      }
      comment
      roomIds
      canceledRoomIds
      isWaitingYourConfirmation
      createdAt
    }
  }
}
    `;
export const GetCachedRoomsDocument = gql`
    query getCachedRooms($projectId: String!) {
  cachedRooms(projectId: $projectId) {
    rooms {
      id
      name
      priority
      floor
      wingId
      wingName
      roomTypeId
      roomTypeName
      isSelectEnabled
      memo
      selectMasterIds
      registrationDueDatetime
      registrationStatus
      publishApplicationStatus
      isLocked
      isEnableOrderApplication
      isEnableProxySelectRegistration
      isEnableRoomUserRegistration
      isEnableRoomUserDestroy
      isEnableUpdateConfirmationCode
      isEnableSelectEmailInvitation
      isEnablePublishApplication
      isEnableChangeToUnselectable
      isEnableSelectEmailAgreementRequest
      isEnableCancelSelectAgreement
      isEnableCancelPublishApplication
      isEnableCancelOrderApplication
      isEnableExcludeRoomsFromPublishApplication
      isEnableExcludeRoomsFromOrderApplication
      orderApplicationCanceledAt
      orderApplicationCancelComment
      user {
        id
        name
        email
        identification {
          status
          code
        }
        selectEmailSentTimes
        agreementRequestEmailSentTimes
        lastSelectEmailSentAt
        lastAgreementRequestEmailSentAt
      }
      orderApplicationStatus
      adminMemo
      confirmationCode
      source
    }
  }
}
    `;
export const GetCommonPageDocument = gql`
    query getCommonPage($id: Int!) {
  commonPage(id: $id) {
    id
    name
    priority
    annotation
    meta {
      isPublic
      displayConsumer
      designFormat
      icon
    }
    assets {
      id
      name
      category
      priority
      fileSize
      externalLink
      meta {
        fileName
        uploadedAt
        UploadedWorksUserBy
      }
      data {
        url
        thumbUrl
      }
    }
  }
}
    `;
export const GetCommonPagesDocument = gql`
    query getCommonPages {
  commonPages {
    commonPages {
      id
      name
      priority
      annotation
      meta {
        isPublic
        displayConsumer
        designFormat
        icon
      }
      assets {
        id
        name
        category
        priority
        fileSize
        externalLink
        meta {
          fileName
          uploadedAt
          UploadedWorksUserBy
        }
        data {
          url
          thumbUrl
        }
      }
    }
  }
}
    `;
export const GetCompanyDocument = gql`
    query getCompany {
  company {
    id
    name
    isIDPassEnabled
    isSAMLEnabled
  }
}
    `;
export const CompanyRolesDocument = gql`
    query companyRoles {
  companyRoles {
    roles {
      id
      name
      policyIds
      users {
        id
        name
      }
    }
  }
}
    `;
export const GetCompassRolesDocument = gql`
    query getCompassRoles {
  compassRoles {
    compassRoles {
      id
      name
      displayName
      priority
    }
  }
}
    `;
export const GetCustomerProjectsDocument = gql`
    query getCustomerProjects($email: String!) {
  customerProjects(email: $email) {
    customerProjects {
      id
      title
      projectCustomerName
      createdAt
      currentSignInAt
      inviterName
      isRoomIamUser
      roomNames
    }
  }
}
    `;
export const GetDiffRoomsDocument = gql`
    query getDiffRooms($projectId: String!) {
  diffRooms(projectId: $projectId) {
    rooms {
      room {
        id
        name
        priority
        floor
        wingId
        wingName
        roomTypeId
        roomTypeName
        isSelectEnabled
        memo
        selectMasterIds
        registrationDueDatetime
        registrationStatus
        publishApplicationStatus
        isLocked
        isEnableOrderApplication
        isEnableProxySelectRegistration
        isEnableRoomUserRegistration
        isEnableRoomUserDestroy
        isEnableUpdateConfirmationCode
        isEnableSelectEmailInvitation
        isEnablePublishApplication
        isEnableChangeToUnselectable
        isEnableSelectEmailAgreementRequest
        isEnableCancelSelectAgreement
        isEnableCancelPublishApplication
        isEnableCancelOrderApplication
        isEnableExcludeRoomsFromPublishApplication
        isEnableExcludeRoomsFromOrderApplication
        orderApplicationCanceledAt
        orderApplicationCancelComment
        user {
          id
          name
          email
          identification {
            status
            code
          }
          selectEmailSentTimes
          agreementRequestEmailSentTimes
          lastSelectEmailSentAt
          lastAgreementRequestEmailSentAt
        }
        orderApplicationStatus
        adminMemo
        confirmationCode
        source
      }
      type
    }
  }
}
    `;
export const GetEmailDomainsDocument = gql`
    query getEmailDomains {
  emailDomains {
    emailDomains {
      id
      allowedDomain
    }
  }
}
    `;
export const GetExternalUserDocument = gql`
    query getExternalUser($userId: Int!) {
  externalUser(id: $userId) {
    user {
      id
      name
      email
      projects {
        id
        title
        adminUrl
        presentationUrl
        role {
          id
          name
          displayName
          priority
        }
        status {
          name
          displayName
          priority
        }
        isDeleting
        isWorksManaged
        assignedAt
      }
      keywords
      createdAt
      updatedAt
    }
  }
}
    `;
export const GetExternalUsersDocument = gql`
    query getExternalUsers {
  externalUsers {
    users {
      id
      email
      name
      keywords
      createdAt
      projectCount
    }
    pagination {
      current
      previous
      next
      limitValue
      pageCount
      totalCount
    }
  }
}
    `;
export const GetGroupingRoomsDocument = gql`
    query getGroupingRooms($projectId: String!) {
  groupingRooms(projectId: $projectId) {
    rooms {
      id
      groupingKey
    }
  }
}
    `;
export const GetLatestImportOptOutJobDocument = gql`
    query getLatestImportOptOutJob {
  latestImportOptoutJob {
    jobId
    status
    rowCount
    failedError
    partFailedError {
      row
      message
    }
    updatedAt
    partFailedTotalCount
    partFailedNormalErrorCount
    partFailedAbnormalErrorCount
  }
}
    `;
export const GetLatestImportRoomUsersJobDocument = gql`
    query getLatestImportRoomUsersJob {
  latestImportRoomUsersJob {
    jobId
    status
    lineCount
    updatedAt
    errorMessage
    errorDetails {
      line
      message
    }
    errorReportS3Url
  }
}
    `;
export const GetMasterDataDocument = gql`
    query getMasterData {
  masterData {
    worksRoles {
      id
      name
      displayName
    }
    companyPolicies {
      id
      name
      displayName
    }
  }
}
    `;
export const GetMyReviewingConfirmationsDocument = gql`
    query getMyReviewingConfirmations {
  myReviewingConfirmations {
    confirmations {
      id
      applicationId
      projectId
      projectName
      applicationWorkflowName
      applicationType
      applicationTitle
      applicationCreatorId
      applicationCreatedAt
      dueDate
    }
  }
}
    `;
export const GetOgpImageDocument = gql`
    query getOgpImage($url: String!) {
  ogpImage(url: $url) {
    url
  }
}
    `;
export const ProfileDocument = gql`
    query profile {
  profile {
    user {
      id
      name
      email
      roleId
      role {
        id
        name
        displayName
      }
      projects {
        id
        title
        adminUrl
        presentationUrl
        role {
          id
          name
          displayName
          priority
        }
        status {
          name
          displayName
          priority
        }
        isDeleting
        isWorksManaged
        assignedAt
      }
      isResetPassword
      keywords
      policies
      companyRoles {
        id
        name
        policyIds
      }
      companyPolicies {
        id
        name
        displayName
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export const GetProjectDocument = gql`
    query getProject($input: String!) {
  project(id: $input) {
    project {
      id
      title
      code
      status {
        name
        displayName
        priority
      }
      zipcode
      prefecture
      city
      address
      structureCount
      roomCount
      planCount
      averagePriceRange
      purchaserCount
      applicationCount
      totalPvCount
      totalSessionCount
      email
      emailDisplayName
      users {
        id
        name
        email
        role {
          id
          name
          displayName
          priority
        }
        isExternal
        assignedAt
        keywords
        companyRoles {
          id
          name
          policyIds
        }
      }
      mainContents {
        id
        name
      }
      adminUrl
      presentationUrl
      isWorksManaged
      showCommonPage
      isDeleting
      createdAt
      updatedAt
    }
  }
}
    `;
export const GetProjectStatusesDocument = gql`
    query getProjectStatuses {
  projectStatuses {
    projectStatuses {
      name
      displayName
      priority
    }
  }
}
    `;
export const GetProjectSummaryDocument = gql`
    query getProjectSummary {
  projectSummary {
    projectCountHistories {
      month
      activatedCount
    }
  }
}
    `;
export const GetProjectsDocument = gql`
    query getProjects {
  projects {
    projects {
      id
      title
      code
      status {
        name
        displayName
        priority
      }
      prefecture
      creator {
        id
        name
      }
      structureCount
      roomCount
      planCount
      averagePriceRange
      purchaserCount
      applicationCount
      adminUrl
      presentationUrl
      isWorksManaged
      isDeleting
      createdAt
      updatedAt
    }
    pagination {
      current
      previous
      next
      limitValue
      pageCount
      totalCount
    }
  }
}
    `;
export const GetRoomSelectMastersDocument = gql`
    query getRoomSelectMasters($projectId: String!, $roomId: Int!) {
  roomSelectMasters(projectId: $projectId, roomId: $roomId) {
    selectMasters {
      id
      selectOptionMasterIds
    }
  }
}
    `;
export const GetRoomSelectRegistrationsDocument = gql`
    query getRoomSelectRegistrations($projectId: String!, $roomIds: [Int!]!) {
  roomSelectRegistrations(projectId: $projectId, roomIds: $roomIds) {
    rooms {
      id
      selects {
        id
        name
        priority
        selectMasterId
        registeredSelectOption {
          id
          name
          isPaid
          child {
            id
            name
            isPaid
          }
        }
      }
    }
  }
}
    `;
export const GetRoomTypesDocument = gql`
    query getRoomTypes($projectId: String!) {
  roomTypes(projectId: $projectId) {
    roomTypes {
      id
      name
      priority
      worksRoomIds
      compassRoomCount
    }
  }
}
    `;
export const GetRoomsDocument = gql`
    query getRooms($projectId: String!) {
  rooms(projectId: $projectId) {
    rooms {
      id
      name
      priority
      floor
      wingId
      wingName
      roomTypeId
      roomTypeName
      isSelectEnabled
      memo
      selectMasterIds
      registrationDueDatetime
      registrationStatus
      publishApplicationStatus
      isLocked
      isEnableOrderApplication
      isEnableProxySelectRegistration
      isEnableRoomUserRegistration
      isEnableRoomUserDestroy
      isEnableUpdateConfirmationCode
      isEnableSelectEmailInvitation
      isEnablePublishApplication
      isEnableChangeToUnselectable
      isEnableSelectEmailAgreementRequest
      isEnableCancelSelectAgreement
      isEnableCancelPublishApplication
      isEnableCancelOrderApplication
      isEnableExcludeRoomsFromPublishApplication
      isEnableExcludeRoomsFromOrderApplication
      orderApplicationCanceledAt
      orderApplicationCancelComment
      user {
        id
        name
        email
        identification {
          status
          code
        }
        selectEmailSentTimes
        agreementRequestEmailSentTimes
        lastSelectEmailSentAt
        lastAgreementRequestEmailSentAt
      }
      orderApplicationStatus
      adminMemo
      confirmationCode
    }
  }
}
    `;
export const SamlIdpDocument = gql`
    query samlIdp {
  samlIdp {
    samlIdp {
      id
      idpSignout
      metadataFile
      metadataFileName
      metadataURL
      attributeMapping {
        email
        name
        department
      }
    }
    assertionConsumerServiceURL
    serviceProviderURN
  }
}
    `;
export const GetContractorHistoriesDocument = gql`
    query getContractorHistories($roomId: Int!) {
  selectContractorHistories(roomId: $roomId) {
    histories {
      timestamp
      actor {
        id
        name
        type
        companyRoleNames
      }
      action
    }
  }
}
    `;
export const GetSelectMastersDocument = gql`
    query getSelectMasters($projectId: String!) {
  selectMasters(projectId: $projectId) {
    selectMasters {
      id
      name
      priority
      displayName
      description
      modelRoomInfo
      annotation
      file {
        url
        thumb {
          url
        }
      }
      fileName
      assignments {
        mainContents
      }
      isPlanSelect
      selectOptionMasters {
        id
        name
        annotation
        isPaid
        priority
        file {
          url
          thumb {
            url
          }
        }
        fileName
        children {
          id
          name
          annotation
          isPaid
          priority
          file {
            url
            thumb {
              url
            }
          }
          fileName
        }
      }
      roomIds
    }
  }
}
    `;
export const GetSelectRegistrationsDocument = gql`
    query getSelectRegistrations($projectId: String!, $roomId: Int!) {
  selectRegistrations(projectId: $projectId, roomId: $roomId) {
    selectRegistrations {
      id
      name
      priority
      selectMasterId
      registeredSelectOption {
        id
        name
        isPaid
        child {
          id
          name
          isPaid
        }
      }
    }
  }
}
    `;
export const GetSelectsDocument = gql`
    query getSelects($projectId: String!, $roomId: Int!) {
  selects(projectId: $projectId, roomId: $roomId) {
    selects {
      id
      priority
      name
      displayName
      description
      modelRoomInfo
      annotation
      selectMasterId
      file {
        url
        thumb {
          url
        }
      }
      assignments {
        mainContents
      }
      isPlanSelect
      selectOptions {
        id
        name
        annotation
        isPaid
        priority
        isSelected
        file {
          url
          thumb {
            url
          }
        }
        children {
          id
          name
          annotation
          isPaid
          priority
          isSelected
          file {
            url
            thumb {
              url
            }
          }
        }
      }
    }
  }
}
    `;
export const GetUserDocument = gql`
    query getUser($userId: Int!) {
  user(id: $userId) {
    user {
      id
      name
      email
      roleId
      role {
        id
        name
        displayName
      }
      projects {
        id
        title
        adminUrl
        presentationUrl
        role {
          id
          name
          displayName
          priority
        }
        status {
          name
          displayName
          priority
        }
        isDeleting
        isWorksManaged
        assignedAt
      }
      isResetPassword
      keywords
      companyRoles {
        id
        name
        policyIds
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export const GetUserCancelDetailsDocument = gql`
    query getUserCancelDetails {
  userCancelDetails {
    userCancelDetails {
      id
      name
      priority
    }
    meta {
      updatedAt
      updatedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
    }
  }
}
    `;
export const UserStageDetailsDocument = gql`
    query userStageDetails {
  userStageDetails {
    userStages {
      id
      stage
      priority
      userStageDetails {
        id
        name
        priority
      }
    }
    meta {
      updatedAt
      updatedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
    }
  }
}
    `;
export const GetUsersDocument = gql`
    query getUsers {
  users {
    users {
      id
      name
      email
      keywords
      roleId
      role {
        id
        name
        displayName
      }
      companyRoles {
        id
        name
        policyIds
      }
      isResetPassword
      projectCount
      createdAt
    }
  }
}
    `;
export const GetWingsDocument = gql`
    query getWings($projectId: String!) {
  wings(projectId: $projectId) {
    wings {
      id
      name
      roomCount
      priority
      roomTypes {
        id
        name
        priority
        worksRoomIds
        compassRoomCount
      }
    }
  }
}
    `;
export const GetWorkflowsDocument = gql`
    query getWorkflows {
  workflows {
    workflows {
      id
      name
      type
      notifiedUserEmailsAnnotation
      workflowSteps {
        id
        label
        stepNumber
        primaryRoleIds
        secondaryRoleIds
        isApproverAddable
        multiApproverCondition
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addExternalUser(variables: AddExternalUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddExternalUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddExternalUserMutation>(AddExternalUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addExternalUser', 'mutation');
    },
    addUser(variables: AddUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserMutation>(AddUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUser', 'mutation');
    },
    AssignUserProjects(variables: AssignUserProjectsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AssignUserProjectsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignUserProjectsMutation>(AssignUserProjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AssignUserProjects', 'mutation');
    },
    AssignUsersProjects(variables: AssignUsersProjectsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AssignUsersProjectsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignUsersProjectsMutation>(AssignUsersProjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AssignUsersProjects', 'mutation');
    },
    bulkUpdateRooms(variables: BulkUpdateRoomsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpdateRoomsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateRoomsMutation>(BulkUpdateRoomsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdateRooms', 'mutation');
    },
    bulkUpdateSelectMasters(variables: BulkUpdateSelectMastersMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpdateSelectMastersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateSelectMastersMutation>(BulkUpdateSelectMastersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdateSelectMasters', 'mutation');
    },
    BulkUpdateUserStageDetails(variables: BulkUpdateUserStageDetailsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpdateUserStageDetailsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateUserStageDetailsMutation>(BulkUpdateUserStageDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BulkUpdateUserStageDetails', 'mutation');
    },
    bulkUpdateWings(variables: BulkUpdateWingsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpdateWingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateWingsMutation>(BulkUpdateWingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdateWings', 'mutation');
    },
    bulkUpdateUserCancelDetails(variables: BulkUpdateUserCancelDetailsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpdateUserCancelDetailsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateUserCancelDetailsMutation>(BulkUpdateUserCancelDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdateUserCancelDetails', 'mutation');
    },
    cancelApplication(variables: CancelApplicationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CancelApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelApplicationMutation>(CancelApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelApplication', 'mutation');
    },
    cancelSelectAgreement(variables: CancelSelectAgreementMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CancelSelectAgreementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelSelectAgreementMutation>(CancelSelectAgreementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelSelectAgreement', 'mutation');
    },
    copySelectMaster(variables: CopySelectMasterMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CopySelectMasterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CopySelectMasterMutation>(CopySelectMasterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'copySelectMaster', 'mutation');
    },
    createAllowedIp(variables: CreateAllowedIpMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateAllowedIpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAllowedIpMutation>(CreateAllowedIpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAllowedIp', 'mutation');
    },
    createApplication(variables: CreateApplicationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateApplicationMutation>(CreateApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createApplication', 'mutation');
    },
    CreateCommonContentAsset(variables: CreateCommonContentAssetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCommonContentAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCommonContentAssetMutation>(CreateCommonContentAssetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateCommonContentAsset', 'mutation');
    },
    CreateCommonContentPage(variables: CreateCommonContentPageMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCommonContentPageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCommonContentPageMutation>(CreateCommonContentPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateCommonContentPage', 'mutation');
    },
    CreateCompanyRole(variables: CreateCompanyRoleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCompanyRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyRoleMutation>(CreateCompanyRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateCompanyRole', 'mutation');
    },
    createCustomerEmailOptOutCsvPresignedUrl(variables?: CreateCustomerEmailOptOutCsvPresignedUrlMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCustomerEmailOptOutCsvPresignedUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomerEmailOptOutCsvPresignedUrlMutation>(CreateCustomerEmailOptOutCsvPresignedUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCustomerEmailOptOutCsvPresignedUrl', 'mutation');
    },
    createProject(variables: CreateProjectMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateProjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProjectMutation>(CreateProjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createProject', 'mutation');
    },
    createRoomUsersCsvPresignedUrl(variables?: CreateRoomUsersCsvPresignedUrlMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateRoomUsersCsvPresignedUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRoomUsersCsvPresignedUrlMutation>(CreateRoomUsersCsvPresignedUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRoomUsersCsvPresignedUrl', 'mutation');
    },
    createRoomsCSV(variables: CreateRoomsCsvMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateRoomsCsvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRoomsCsvMutation>(CreateRoomsCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRoomsCSV', 'mutation');
    },
    createSAMLIdp(variables: CreateSamlIdpMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateSamlIdpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSamlIdpMutation>(CreateSamlIdpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSAMLIdp', 'mutation');
    },
    CreateSelectMaster(variables: CreateSelectMasterMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateSelectMasterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSelectMasterMutation>(CreateSelectMasterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSelectMaster', 'mutation');
    },
    createWorkflow(variables: CreateWorkflowMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateWorkflowMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWorkflowMutation>(CreateWorkflowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWorkflow', 'mutation');
    },
    deleteAllowedIp(variables: DeleteAllowedIpMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteAllowedIpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAllowedIpMutation>(DeleteAllowedIpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAllowedIp', 'mutation');
    },
    DeleteCommonContentAsset(variables: DeleteCommonContentAssetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteCommonContentAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCommonContentAssetMutation>(DeleteCommonContentAssetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteCommonContentAsset', 'mutation');
    },
    DeleteCommonContentPage(variables: DeleteCommonContentPageMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteCommonContentPageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCommonContentPageMutation>(DeleteCommonContentPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteCommonContentPage', 'mutation');
    },
    deleteCompanyRole(variables: DeleteCompanyRoleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteCompanyRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCompanyRoleMutation>(DeleteCompanyRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCompanyRole', 'mutation');
    },
    destroyRoomUser(variables: DestroyRoomUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DestroyRoomUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DestroyRoomUserMutation>(DestroyRoomUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'destroyRoomUser', 'mutation');
    },
    deleteCustomer(variables: DeleteCustomerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCustomerMutation>(DeleteCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCustomer', 'mutation');
    },
    deleteProject(variables: DeleteProjectMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteProjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteProjectMutation>(DeleteProjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteProject', 'mutation');
    },
    deleteSAMLIdp(variables: DeleteSamlIdpMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteSamlIdpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSamlIdpMutation>(DeleteSamlIdpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSAMLIdp', 'mutation');
    },
    deleteUser(variables: DeleteUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUserMutation>(DeleteUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteUser', 'mutation');
    },
    exchangeAuthCodeWithAccessToken(variables: ExchangeAuthCodeWithAccessTokenMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ExchangeAuthCodeWithAccessTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExchangeAuthCodeWithAccessTokenMutation>(ExchangeAuthCodeWithAccessTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exchangeAuthCodeWithAccessToken', 'mutation');
    },
    excludeRoomsFromOrderApplication(variables: ExcludeRoomsFromOrderApplicationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ExcludeRoomsFromOrderApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExcludeRoomsFromOrderApplicationMutation>(ExcludeRoomsFromOrderApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'excludeRoomsFromOrderApplication', 'mutation');
    },
    excludeRoomsFromPublishApplication(variables: ExcludeRoomsFromPublishApplicationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ExcludeRoomsFromPublishApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExcludeRoomsFromPublishApplicationMutation>(ExcludeRoomsFromPublishApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'excludeRoomsFromPublishApplication', 'mutation');
    },
    forceUpdateExternalUserPassword(variables: ForceUpdateExternalUserPasswordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ForceUpdateExternalUserPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForceUpdateExternalUserPasswordMutation>(ForceUpdateExternalUserPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'forceUpdateExternalUserPassword', 'mutation');
    },
    forceUpdateUserPassword(variables: ForceUpdateUserPasswordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ForceUpdateUserPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForceUpdateUserPasswordMutation>(ForceUpdateUserPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'forceUpdateUserPassword', 'mutation');
    },
    forgetPasswordEmail(variables: ForgetPasswordEmailMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ForgetPasswordEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForgetPasswordEmailMutation>(ForgetPasswordEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'forgetPasswordEmail', 'mutation');
    },
    idPassLogin(variables: IdPassLoginMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IdPassLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IdPassLoginMutation>(IdPassLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'idPassLogin', 'mutation');
    },
    logout(variables: LogoutMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>(LogoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'logout', 'mutation');
    },
    notifyFinishedUploadContractorCsv(variables: NotifyFinishedUploadContractorCsvMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<NotifyFinishedUploadContractorCsvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotifyFinishedUploadContractorCsvMutation>(NotifyFinishedUploadContractorCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'notifyFinishedUploadContractorCsv', 'mutation');
    },
    notifyFinishedUploadCustomerEmailOptOutCsv(variables: NotifyFinishedUploadCustomerEmailOptOutCsvMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<NotifyFinishedUploadCustomerEmailOptOutCsvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotifyFinishedUploadCustomerEmailOptOutCsvMutation>(NotifyFinishedUploadCustomerEmailOptOutCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'notifyFinishedUploadCustomerEmailOptOutCsv', 'mutation');
    },
    refreshAuthToken(variables: RefreshAuthTokenMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RefreshAuthTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshAuthTokenMutation>(RefreshAuthTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refreshAuthToken', 'mutation');
    },
    registerContractor(variables: RegisterContractorMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RegisterContractorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterContractorMutation>(RegisterContractorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registerContractor', 'mutation');
    },
    registerSelects(variables: RegisterSelectsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RegisterSelectsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterSelectsMutation>(RegisterSelectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registerSelects', 'mutation');
    },
    ReorderCommonContentAssets(variables: ReorderCommonContentAssetsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReorderCommonContentAssetsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReorderCommonContentAssetsMutation>(ReorderCommonContentAssetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReorderCommonContentAssets', 'mutation');
    },
    ReorderCommonContentPages(variables: ReorderCommonContentPagesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReorderCommonContentPagesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReorderCommonContentPagesMutation>(ReorderCommonContentPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReorderCommonContentPages', 'mutation');
    },
    sendSelectEmail(variables: SendSelectEmailMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SendSelectEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendSelectEmailMutation>(SendSelectEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendSelectEmail', 'mutation');
    },
    updateAllowedIp(variables: UpdateAllowedIpMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateAllowedIpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAllowedIpMutation>(UpdateAllowedIpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAllowedIp', 'mutation');
    },
    updateApplicationStepConfirmation(variables: UpdateApplicationStepConfirmationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateApplicationStepConfirmationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateApplicationStepConfirmationMutation>(UpdateApplicationStepConfirmationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateApplicationStepConfirmation', 'mutation');
    },
    UpdateCommonContentAsset(variables: UpdateCommonContentAssetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCommonContentAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCommonContentAssetMutation>(UpdateCommonContentAssetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCommonContentAsset', 'mutation');
    },
    UpdateCommonContentPage(variables: UpdateCommonContentPageMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCommonContentPageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCommonContentPageMutation>(UpdateCommonContentPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCommonContentPage', 'mutation');
    },
    updateCompanyAuthMethod(variables: UpdateCompanyAuthMethodMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyAuthMethodMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyAuthMethodMutation>(UpdateCompanyAuthMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyAuthMethod', 'mutation');
    },
    UpdateCompanyRole(variables: UpdateCompanyRoleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyRoleMutation>(UpdateCompanyRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCompanyRole', 'mutation');
    },
    updateRoomUserConfirmationCode(variables: UpdateRoomUserConfirmationCodeMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateRoomUserConfirmationCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRoomUserConfirmationCodeMutation>(UpdateRoomUserConfirmationCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRoomUserConfirmationCode', 'mutation');
    },
    UpdateExternalUserName(variables: UpdateExternalUserNameMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateExternalUserNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateExternalUserNameMutation>(UpdateExternalUserNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateExternalUserName', 'mutation');
    },
    updateInitialPassword(variables: UpdateInitialPasswordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInitialPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInitialPasswordMutation>(UpdateInitialPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInitialPassword', 'mutation');
    },
    UpdateInternalUserName(variables: UpdateInternalUserNameMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInternalUserNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInternalUserNameMutation>(UpdateInternalUserNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateInternalUserName', 'mutation');
    },
    updateIpRestriction(variables: UpdateIpRestrictionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateIpRestrictionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateIpRestrictionMutation>(UpdateIpRestrictionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateIpRestriction', 'mutation');
    },
    updatePassword(variables: UpdatePasswordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePasswordMutation>(UpdatePasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePassword', 'mutation');
    },
    updateProfileName(variables: UpdateProfileNameMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateProfileNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProfileNameMutation>(UpdateProfileNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProfileName', 'mutation');
    },
    updateProject(variables: UpdateProjectMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateProjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProjectMutation>(UpdateProjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProject', 'mutation');
    },
    updateProjectShowCommonPage(variables: UpdateProjectShowCommonPageMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateProjectShowCommonPageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProjectShowCommonPageMutation>(UpdateProjectShowCommonPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProjectShowCommonPage', 'mutation');
    },
    updateRoom(variables: UpdateRoomMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateRoomMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRoomMutation>(UpdateRoomDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRoom', 'mutation');
    },
    updateSAMLIdp(variables: UpdateSamlIdpMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateSamlIdpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSamlIdpMutation>(UpdateSamlIdpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSAMLIdp', 'mutation');
    },
    UpdateUserCompanyRoles(variables: UpdateUserCompanyRolesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserCompanyRolesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserCompanyRolesMutation>(UpdateUserCompanyRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserCompanyRoles', 'mutation');
    },
    UpdateUserKeywords(variables: UpdateUserKeywordsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserKeywordsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserKeywordsMutation>(UpdateUserKeywordsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserKeywords', 'mutation');
    },
    updateWorksRole(variables: UpdateWorksRoleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateWorksRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWorksRoleMutation>(UpdateWorksRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWorksRole', 'mutation');
    },
    checkLoginSetting(variables: CheckLoginSettingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckLoginSettingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckLoginSettingMutation>(CheckLoginSettingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkLoginSetting', 'mutation');
    },
    checkUserCancelDetailUsage(variables: CheckUserCancelDetailUsageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckUserCancelDetailUsageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckUserCancelDetailUsageQuery>(CheckUserCancelDetailUsageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkUserCancelDetailUsage', 'query');
    },
    checkUserStageDetailUsage(variables: CheckUserStageDetailUsageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckUserStageDetailUsageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckUserStageDetailUsageQuery>(CheckUserStageDetailUsageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkUserStageDetailUsage', 'query');
    },
    getAllRoomSelectRegistrations(variables: GetAllRoomSelectRegistrationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAllRoomSelectRegistrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllRoomSelectRegistrationsQuery>(GetAllRoomSelectRegistrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllRoomSelectRegistrations', 'query');
    },
    getAllowedIps(variables?: GetAllowedIpsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAllowedIpsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllowedIpsQuery>(GetAllowedIpsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllowedIps', 'query');
    },
    getApplications(variables: GetApplicationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetApplicationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetApplicationsQuery>(GetApplicationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getApplications', 'query');
    },
    getCachedRooms(variables: GetCachedRoomsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCachedRoomsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCachedRoomsQuery>(GetCachedRoomsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCachedRooms', 'query');
    },
    getCommonPage(variables: GetCommonPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCommonPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCommonPageQuery>(GetCommonPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCommonPage', 'query');
    },
    getCommonPages(variables?: GetCommonPagesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCommonPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCommonPagesQuery>(GetCommonPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCommonPages', 'query');
    },
    getCompany(variables?: GetCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCompanyQuery>(GetCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCompany', 'query');
    },
    companyRoles(variables?: CompanyRolesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CompanyRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyRolesQuery>(CompanyRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyRoles', 'query');
    },
    getCompassRoles(variables?: GetCompassRolesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCompassRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCompassRolesQuery>(GetCompassRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCompassRoles', 'query');
    },
    getCustomerProjects(variables: GetCustomerProjectsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCustomerProjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCustomerProjectsQuery>(GetCustomerProjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCustomerProjects', 'query');
    },
    getDiffRooms(variables: GetDiffRoomsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDiffRoomsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDiffRoomsQuery>(GetDiffRoomsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDiffRooms', 'query');
    },
    getEmailDomains(variables?: GetEmailDomainsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetEmailDomainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEmailDomainsQuery>(GetEmailDomainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getEmailDomains', 'query');
    },
    getExternalUser(variables: GetExternalUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetExternalUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetExternalUserQuery>(GetExternalUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getExternalUser', 'query');
    },
    getExternalUsers(variables?: GetExternalUsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetExternalUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetExternalUsersQuery>(GetExternalUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getExternalUsers', 'query');
    },
    getGroupingRooms(variables: GetGroupingRoomsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetGroupingRoomsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGroupingRoomsQuery>(GetGroupingRoomsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGroupingRooms', 'query');
    },
    getLatestImportOptOutJob(variables?: GetLatestImportOptOutJobQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetLatestImportOptOutJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLatestImportOptOutJobQuery>(GetLatestImportOptOutJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLatestImportOptOutJob', 'query');
    },
    getLatestImportRoomUsersJob(variables?: GetLatestImportRoomUsersJobQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetLatestImportRoomUsersJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLatestImportRoomUsersJobQuery>(GetLatestImportRoomUsersJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLatestImportRoomUsersJob', 'query');
    },
    getMasterData(variables?: GetMasterDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMasterDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMasterDataQuery>(GetMasterDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMasterData', 'query');
    },
    getMyReviewingConfirmations(variables?: GetMyReviewingConfirmationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMyReviewingConfirmationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMyReviewingConfirmationsQuery>(GetMyReviewingConfirmationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMyReviewingConfirmations', 'query');
    },
    getOgpImage(variables: GetOgpImageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOgpImageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOgpImageQuery>(GetOgpImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOgpImage', 'query');
    },
    profile(variables?: ProfileQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileQuery>(ProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profile', 'query');
    },
    getProject(variables: GetProjectQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectQuery>(GetProjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProject', 'query');
    },
    getProjectStatuses(variables?: GetProjectStatusesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProjectStatusesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectStatusesQuery>(GetProjectStatusesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProjectStatuses', 'query');
    },
    getProjectSummary(variables?: GetProjectSummaryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProjectSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectSummaryQuery>(GetProjectSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProjectSummary', 'query');
    },
    getProjects(variables?: GetProjectsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectsQuery>(GetProjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProjects', 'query');
    },
    getRoomSelectMasters(variables: GetRoomSelectMastersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetRoomSelectMastersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRoomSelectMastersQuery>(GetRoomSelectMastersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRoomSelectMasters', 'query');
    },
    getRoomSelectRegistrations(variables: GetRoomSelectRegistrationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetRoomSelectRegistrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRoomSelectRegistrationsQuery>(GetRoomSelectRegistrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRoomSelectRegistrations', 'query');
    },
    getRoomTypes(variables: GetRoomTypesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetRoomTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRoomTypesQuery>(GetRoomTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRoomTypes', 'query');
    },
    getRooms(variables: GetRoomsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetRoomsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRoomsQuery>(GetRoomsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRooms', 'query');
    },
    samlIdp(variables?: SamlIdpQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SamlIdpQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamlIdpQuery>(SamlIdpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'samlIdp', 'query');
    },
    getContractorHistories(variables: GetContractorHistoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetContractorHistoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetContractorHistoriesQuery>(GetContractorHistoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getContractorHistories', 'query');
    },
    getSelectMasters(variables: GetSelectMastersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSelectMastersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSelectMastersQuery>(GetSelectMastersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSelectMasters', 'query');
    },
    getSelectRegistrations(variables: GetSelectRegistrationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSelectRegistrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSelectRegistrationsQuery>(GetSelectRegistrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSelectRegistrations', 'query');
    },
    getSelects(variables: GetSelectsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSelectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSelectsQuery>(GetSelectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSelects', 'query');
    },
    getUser(variables: GetUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserQuery>(GetUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUser', 'query');
    },
    getUserCancelDetails(variables?: GetUserCancelDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserCancelDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserCancelDetailsQuery>(GetUserCancelDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserCancelDetails', 'query');
    },
    userStageDetails(variables?: UserStageDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserStageDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserStageDetailsQuery>(UserStageDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userStageDetails', 'query');
    },
    getUsers(variables?: GetUsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersQuery>(GetUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUsers', 'query');
    },
    getWings(variables: GetWingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetWingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetWingsQuery>(GetWingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getWings', 'query');
    },
    getWorkflows(variables?: GetWorkflowsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetWorkflowsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetWorkflowsQuery>(GetWorkflowsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getWorkflows', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;